(function($) {
  'use strict';

  const STORE_DOMAIN = "saskatoontees-ca.myshopify.com";
  const WORKER_URL   = "https://wandering-heart-9eb7.blinkbasketstore.workers.dev";
  const IMGLY_CDN    = 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.4.5/dist/browser.js';

  const DISCOUNT_TIERS = [
    { min: 1,   max: 11,       discount: 0    },
    { min: 12,  max: 23,       discount: 0.12 },
    { min: 24,  max: 47,       discount: 0.18 },
    { min: 48,  max: 71,       discount: 0.24 },
    { min: 72,  max: 99,       discount: 0.28 },
    { min: 100, max: Infinity, discount: 0.35 },
  ];

  const getPrintSurcharge = (qty) => qty < 24 ? 9 : 8;
  const SIZE_UPCHARGE = 4;
  const SIZE_UPCHARGE_THRESHOLD = ['2XL','3XL','4XL','5XL'];

  const ARTWORK_CSS = `
    .mrk-artwork-overlay{position:absolute;z-index:8;overflow:visible!important;}
    .mrk-artwork-overlay.mrk-artwork--on-top{z-index:12;}
    .mrk-artwork-overlay__canvas{overflow:visible!important;}
    .mrk-artwork-item{position:absolute!important;left:50%!important;top:50%!important;transform-origin:center center!important;overflow:visible!important;display:inline-block;cursor:move;user-select:none;-webkit-user-select:none;}
    .mrk-artwork-item__image{display:block;max-width:180px;max-height:180px;pointer-events:none;}
    .mrk-artwork-item__control{position:absolute!important;width:28px!important;height:28px!important;border-radius:50%!important;border:2px solid #fff!important;cursor:pointer!important;background:#555!important;color:#fff!important;font-size:14px!important;font-weight:900!important;line-height:1!important;display:flex!important;align-items:center!important;justify-content:center!important;z-index:20!important;pointer-events:none!important;box-shadow:0 2px 6px rgba(0,0,0,.4)!important;padding:0!important;opacity:0!important;transition:opacity .15s!important;}
    .mrk-artwork-item__remove{top:-14px!important;right:-14px!important;background:#EF4444!important;font-size:16px!important;}
    .mrk-artwork-item__resize{bottom:-14px!important;right:-14px!important;background:#333!important;font-size:12px!important;cursor:se-resize!important;}
    .mrk-artwork-item__rotate{bottom:-14px!important;left:-14px!important;background:#333!important;font-size:13px!important;cursor:grab!important;}
    .mrk-artwork-item__bar{position:absolute;bottom:calc(100% + 9px);left:50%;transform:translateX(-50%);display:none;align-items:center;background:#111;border-radius:9px;padding:3px 5px;gap:1px;white-space:nowrap;pointer-events:auto;z-index:30;box-shadow:0 4px 14px rgba(0,0,0,.45);}
    .mrk-artwork-item__bar::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:#111;}
    .mrk-artwork-item__bar-btn{background:none;border:none;color:#fff;font-size:.68rem;font-weight:700;cursor:pointer;padding:5px 8px;border-radius:6px;text-transform:uppercase;letter-spacing:.04em;display:flex;align-items:center;gap:3px;transition:background .12s;line-height:1;}
    .mrk-artwork-item__bar-btn:hover{background:rgba(255,255,255,.15);}
    .mrk-artwork-item__bar-btn:disabled{opacity:.45;cursor:not-allowed;}
    .mrk-artwork-item__bar-sep{width:1px;height:14px;background:rgba(255,255,255,.15);margin:0 2px;}
    .mrk-artwork-item__rmbg{color:#FFD300;}
    .mrk-artwork--on-top .mrk-artwork-item__raise{color:#FFD300;}
    @media(hover:hover){.mrk-artwork-item:hover .mrk-artwork-item__control{opacity:1!important;pointer-events:auto!important;}.mrk-artwork-item:hover .mrk-artwork-item__bar{display:flex!important;}}
    .mrk-artwork-item--active .mrk-artwork-item__control{opacity:1!important;pointer-events:auto!important;}
    .mrk-artwork-item--active .mrk-artwork-item__bar{display:flex!important;}
    .mrk-artwork-item--active{outline:2px dashed rgba(132,0,255,.65)!important;outline-offset:5px;}
    .mrk-artwork-item:not(.mrk-artwork-item--active){outline:none!important;}
    .mrk-position-btn{position:relative;}
    .mrk-position-btn__remove{position:absolute;top:-12px;left:-12px;width:30px;height:30px;background:#111;color:#fff;border:none;border-radius:50%;font-size:20px;cursor:pointer;display:none;align-items:center;justify-content:center;z-index:20;padding:0;line-height:1;pointer-events:auto!important;}
    .mrk-position-btn__remove:hover{background:#333;}

    .mrk-preview-wrapper,
    .mrk-product-media-preview,
    [class*="mrk-preview"],
    [class*="mrk-product-media"],
    .mrk-customizer__preview,
    .mrk-preview-container{
      background:#ffffff!important;
      background-color:#ffffff!important;
    }

    button.skt-img-swatch{
      width:56px!important; height:56px!important;
      border-radius:8px!important;
      padding:0!important;
      border:2px solid #e0e0e0!important;
      transition:border-color .15s,box-shadow .15s!important;
      overflow:hidden!important; flex-shrink:0!important;
      background:#f0f0f0!important;
      position:relative!important;
    }
    button.skt-img-swatch:hover{ border-color:#8400FF!important; }
    button.skt-img-swatch.mrk-swatch--active{
      border-color:#8400FF!important;
      box-shadow:0 0 0 3px rgba(132,0,255,.22)!important;
    }
    button.skt-img-swatch.mrk-swatch--light{ border-color:#ccc!important; }
    span.skt-img-inner{
      display:block!important;
      width:100%!important; height:100%!important;
      border-radius:6px!important;
      background-size:260%!important;
      background-position:center 38%!important;
      background-repeat:no-repeat!important;
    }
    #skt-mqb-swatches .skt-mqb__sw{
      width:38px!important; height:38px!important;
      border-radius:6px!important;
      background-size:260%!important;
      background-position:center 38%!important;
    }

    #mrk-rmbg-progress{
      position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:999999;
      display:flex;align-items:center;justify-content:center;
    }
    #mrk-rmbg-progress__box{
      background:#111;border:2px solid #8400FF;border-radius:16px;
      box-shadow:0 0 32px rgba(132,0,255,.4);
      padding:36px 44px;max-width:380px;width:90%;text-align:center;
    }
    #mrk-rmbg-progress__icon{font-size:42px;display:block;margin-bottom:14px;}
    #mrk-rmbg-progress__title{
      font-family:'Oswald',sans-serif;font-weight:900;font-size:1.1rem;
      text-transform:uppercase;letter-spacing:.07em;color:#fff;margin:0 0 6px;
    }
    #mrk-rmbg-progress__sub{font-size:.8rem;color:rgba(255,255,255,.45);margin:0 0 22px;line-height:1.5;}
    #mrk-rmbg-progress__track{height:5px;background:rgba(255,255,255,.1);border-radius:3px;overflow:hidden;}
    #mrk-rmbg-progress__fill{height:100%;background:linear-gradient(90deg,#8400FF,#FFD300);border-radius:3px;width:0%;transition:width .4s ease;}

    #mrk-rmbg-popup{
      position:fixed;inset:0;background:rgba(0,0,0,.72);z-index:999999;
      display:flex;align-items:center;justify-content:center;padding:16px;
      overflow-y:auto;
    }
    #mrk-rmbg-box{
      background:#fff;border:2px solid #111;border-radius:16px;
      box-shadow:6px 6px 0 0 #FFD300;width:100%;max-width:420px;
      overflow:hidden;margin:auto;
    }
    .mrk-rmbg-hd{
      background:#111;padding:14px 18px;
      display:flex;align-items:center;justify-content:space-between;
    }
    .mrk-rmbg-hd h3{
      font-family:'Oswald',sans-serif;font-weight:900;font-size:1rem;
      text-transform:uppercase;letter-spacing:.07em;color:#FFD300;margin:0;
    }
    .mrk-rmbg-close{
      background:none;border:none;color:rgba(255,255,255,.55);font-size:1.3rem;
      cursor:pointer;line-height:1;padding:0 0 0 10px;transition:color .15s;
    }
    .mrk-rmbg-close:hover{color:#fff;}
    .mrk-rmbg-body{padding:18px 18px 20px;}
    .mrk-rmbg-intro{
      font-size:.82rem;color:#555;margin:0 0 14px;line-height:1.55;
      padding:10px 12px;background:#faf5ff;border-radius:8px;
      border-left:3px solid #8400FF;
    }
    .mrk-rmbg-intro strong{color:#8400FF;}
    .mrk-rmbg-tools{display:flex;flex-direction:column;gap:8px;margin-bottom:16px;}
    .mrk-rmbg-tool{
      display:flex;align-items:center;justify-content:space-between;
      padding:10px 14px;border:1.5px solid #e5e7eb;border-radius:10px;
      text-decoration:none;transition:border-color .15s,background .15s;
      gap:10px;
    }
    .mrk-rmbg-tool:hover{border-color:#8400FF;background:#faf5ff;}
    .mrk-rmbg-tool__info{flex:1;min-width:0;}
    .mrk-rmbg-tool__name{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:.88rem;
      color:#111;text-transform:uppercase;letter-spacing:.04em;
      display:block;margin-bottom:2px;
    }
    .mrk-rmbg-tool__desc{font-size:.72rem;color:#888;display:block;line-height:1.3;}
    .mrk-rmbg-tool__badge{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:.65rem;
      text-transform:uppercase;letter-spacing:.05em;padding:3px 8px;
      border-radius:20px;white-space:nowrap;flex-shrink:0;
    }
    .mrk-rmbg-tool__badge--free{background:#f0fdf4;color:#166534;border:1.5px solid #86efac;}
    .mrk-rmbg-tool__badge--best{background:#fffbeb;color:#92400e;border:1.5px solid #fcd34d;}
    .mrk-rmbg-divider{
      display:flex;align-items:center;gap:8px;margin:14px 0 12px;
      font-size:.7rem;font-weight:700;text-transform:uppercase;
      letter-spacing:.07em;color:#aaa;
    }
    .mrk-rmbg-divider::before,.mrk-rmbg-divider::after{
      content:'';flex:1;height:1px;background:#e5e7eb;
    }
    .mrk-rmbg-reupload-wrap{text-align:center;}
    .mrk-rmbg-reupload-label{
      font-size:.75rem;color:#777;margin:0 0 8px;line-height:1.4;
    }
    .mrk-rmbg-btn--up{
      display:inline-flex;align-items:center;justify-content:center;gap:7px;
      width:100%;padding:11px 16px;background:#FFD300;color:#111;
      border:2px solid #FFD300;border-radius:10px;
      font-family:'Oswald',sans-serif;font-weight:900;font-size:.82rem;
      text-transform:uppercase;letter-spacing:.06em;cursor:pointer;
      transition:background .15s;
    }
    .mrk-rmbg-btn--up:hover{background:#ffc800;border-color:#ffc800;}
    .mrk-rmbg-done{
      display:none;margin-top:8px;padding:9px 14px;
      background:#f0fdf4;border:1.5px solid #86efac;border-radius:8px;
      color:#166534;font-size:.78rem;font-weight:600;text-align:center;
    }
    .mrk-rmbg-tip{
      font-size:.7rem;color:#aaa;text-align:center;margin:10px 0 0;line-height:1.4;
    }
  `;

  const FILE_MODAL_CSS = `
    .mrk-file-tabs,.mrk-file-tab-nav,.mrk-file-tab{display:none!important;}
    .mrk-file-tab-content{display:block!important;}
    .mrk-file-tab-content[data-tab="upload"]{display:none!important;}
    #mrk-file-library{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;padding:4px 0;}
  `;

  const MOBILE_BAR_CSS = `
    #skt-mqb{display:none!important;}
    .skt-mqb-step1{display:none!important;}
    #mrk-position-buttons,.skt-mqb-step2>h2,.skt-mqb-step2>h3,.skt-mqb-step2>h4,.skt-mqb-step2 .mrk-section-title{display:none!important;}
    .skt-hide-mobile{display:none!important;}
    [id^="skt-text-overlay-"]{height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;line-height:0!important;}
    #skt-mqb{background:rgba(132,0,255,0.04);border:2px solid #8400FF;border-radius:14px;margin:0 0 14px;overflow:visible;box-shadow:0 3px 14px rgba(132,0,255,0.12);}
    .skt-mqb__sec{padding:10px 12px;border-bottom:1px solid rgba(132,0,255,0.12);}
    .skt-mqb__sec:last-child{border-bottom:none;}
    .skt-mqb__positions{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;}
    .skt-mqb__pos{border:2px solid rgba(132,0,255,0.2);border-radius:8px;background:rgba(255,255,255,0.7);cursor:pointer;padding:3px 3px 5px;display:flex;flex-direction:column;align-items:center;gap:3px;transition:border-color .15s,background .15s;overflow:visible;position:relative;}
    .skt-mqb__pos:active{transform:scale(.96);}
    .skt-mqb__pos-img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:5px;display:block;background:#efe8ff;}
    .skt-mqb__pos-lbl{font-family:'Oswald',sans-serif;font-size:.62rem;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#6b21a8;line-height:1;}
    .skt-mqb__pos--on{border-color:#8400FF;background:#f0e6ff;}
    .skt-mqb__pos--on .skt-mqb__pos-lbl{color:#8400FF;}
    .skt-mqb__pos-dot{position:absolute;top:5px;right:5px;width:8px;height:8px;border-radius:50%;background:#22C55E;border:1.5px solid #fff;display:none;z-index:5;}
    .skt-mqb__pos--has .skt-mqb__pos-dot{display:block;}
    .skt-mqb__pos-del{position:absolute;top:-7px;right:-7px;width:20px;height:20px;border-radius:50%;background:#EF4444;color:#fff;border:2px solid #fff;font-size:12px;font-weight:900;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:30;padding:0;line-height:1;box-shadow:0 1px 4px rgba(0,0,0,.25);transition:transform .12s,background .12s;}
    .skt-mqb__pos-del:hover{background:#DC2626;transform:scale(1.15);}
    .skt-mqb__pos-del:active{transform:scale(.9);}
    .skt-mqb__colour-row{display:flex;align-items:center;gap:8px;margin-bottom:7px;}
    .skt-mqb__colour-name{font-family:'Oswald',sans-serif;font-size:.82rem;font-weight:600;color:#3b1465;}
    .skt-mqb__swatches{display:flex;gap:7px;overflow-x:auto;padding:2px 0 4px;scrollbar-width:none;-webkit-overflow-scrolling:touch;}
    .skt-mqb__swatches::-webkit-scrollbar{display:none;}
    .skt-mqb__sw{width:28px;height:28px;border-radius:50%;border:2px solid transparent;flex-shrink:0;cursor:pointer;transition:transform .15s,border-color .15s;}
    .skt-mqb__sw--light{border-color:#c4b5fd!important;}
    .skt-mqb__sw--on{border-color:#8400FF!important;transform:scale(1.18);box-shadow:0 0 0 2.5px rgba(132,0,255,.25);}
    .skt-mqb__btns{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
    .skt-mqb__btn{padding:12px 8px 10px;border:2px solid rgba(132,0,255,0.25);border-radius:11px;background:rgba(255,255,255,0.8);cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:'Oswald',sans-serif;font-size:.72rem;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#5b21b6;transition:background .15s,border-color .15s;line-height:1.2;}
    .skt-mqb__btn:active{transform:scale(.97);}
    .skt-mqb__btn--upload{border-color:#8400FF;color:#8400FF;}
    .skt-mqb__btn--upload:hover{background:#f5f0ff;}
    .skt-mqb__btn--upload-done{border-color:#22C55E!important;background:#f0fdf4!important;color:#166534!important;}
    .skt-mqb__btn--text{border-color:#FFD300;background:rgba(255,211,0,0.1);color:#333;}
    .skt-mqb__btn--text:hover{background:rgba(255,211,0,0.2);}
    .skt-mqb__help{display:flex;align-items:center;justify-content:center;gap:7px;width:100%;padding:11px 12px;background:#FFD300;border:none;border-radius:9px;font-family:'Oswald',sans-serif;font-size:.78rem;font-weight:900;text-transform:uppercase;letter-spacing:.07em;color:#111;cursor:pointer;transition:background .15s;text-decoration:none;}
    .skt-mqb__help:hover{background:#ffc800;}
    .skt-mqb__help:active{transform:scale(.97);}
  `;
  // ── Step Accordion CSS — SKT Design System ────────────────────────────────
  const SKT_STEPS_CSS = `

    /* ── Wrapper ── */
    #skt-steps-wrapper{display:flex;flex-direction:column;gap:12px;margin-bottom:20px;}

    /* ── Step card ── */
    .skt-step{
      background:#fff;
      border:2px solid #E5E7EB;
      border-radius:16px;
      overflow:visible;
      transition:border-color .2s,box-shadow .2s;
    }
    .skt-step--active{
      border-color:#111111;
      box-shadow:4px 4px 0 0 #FFD300;
    }
    .skt-step--done{
      border-color:#FFD300;
    }

    /* ── Number circle ── */
    .skt-step__num{
      width:34px;height:34px;border-radius:50%;
      border:2px solid #E5E7EB;
      display:flex;align-items:center;justify-content:center;
      font-family:'Oswald',sans-serif;font-weight:900;font-size:15px;
      color:#ccc;flex-shrink:0;transition:all .2s;
    }
    .skt-step--active .skt-step__num{
      background:#111111;border-color:#111111;color:#FFD300;
    }
    .skt-step--done .skt-step__num{
      background:#FFD300;border-color:#111111;color:#111111;font-size:17px;
    }

    /* ── Step header ── */
    .skt-step__hd{
      display:flex;align-items:center;gap:12px;
      padding:15px 20px;cursor:pointer;user-select:none;border-radius:14px;
    }
    .skt-step--active .skt-step__hd{border-radius:14px 14px 0 0;}

    /* ── Title group ── */
    .skt-step__titles{flex:1;min-width:0;}
    .skt-step__eyebrow{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:0.6rem;
      text-transform:uppercase;letter-spacing:.18em;color:#8400FF;
      display:block;margin-bottom:2px;
    }
    .skt-step__label{
      font-family:'Oswald',sans-serif;font-weight:900;font-size:15px;
      letter-spacing:.04em;text-transform:uppercase;color:#111111;line-height:1.1;
    }
    .skt-step--active .skt-step__label{color:#111111;}
    .skt-step__sub{font-size:11px;color:#6B7280;margin-top:2px;line-height:1.3;}

    /* ── Value preview (right side) ── */
    .skt-step__preview{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;
      color:#8400FF;text-transform:uppercase;
      text-align:right;flex-shrink:0;
      max-width:90px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;
    }

    /* ── Chevron ── */
    .skt-step__chevron{color:#ccc;transition:transform .2s;flex-shrink:0;}
    .skt-step--active .skt-step__chevron{transform:rotate(180deg);color:#111111;}

    /* ── Step body ── */
    .skt-step__bd{
      display:none;
      padding:16px 20px 20px;
      border-top:2px solid #F4F4F6;
    }
    .skt-step--active .skt-step__bd{display:block;}

    /* ── Step 1: Color name display ── */
    .skt-color-name-row{
      margin-top:14px;
      display:flex;align-items:center;gap:8px;
      padding:9px 12px;
      background:#F4F4F6;border-radius:8px;
      border-left:3px solid #8400FF;
    }
    .skt-color-name-row .skt-cn-label{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;
      text-transform:uppercase;letter-spacing:.1em;color:#6B7280;
    }
    .skt-color-name-row strong{
      font-family:'Oswald',sans-serif;font-weight:900;font-size:13px;color:#111111;
    }

    /* ── Step 1: circular swatches ── */
    #skt-step-1 button.skt-img-swatch{width:38px!important;height:38px!important;border-radius:50%!important;}
    #skt-step-1 span.skt-img-inner{border-radius:50%!important;}
    #skt-step-1 button.skt-img-swatch.mrk-swatch--active{
      border-color:#FFD300!important;
      box-shadow:0 0 0 2px #fff,0 0 0 4px #FFD300!important;
    }
    #skt-step-1 #mrk-color-swatches{display:flex!important;flex-wrap:wrap!important;gap:9px!important;padding-top:4px!important;}

    /* ── Step 2: Position tile grid ── */
    .skt-pos-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:10px;}
    .skt-pos-tile{
      background:#F4F4F6;border:2px solid #E5E7EB;border-radius:10px;
      padding:10px 6px 10px;cursor:pointer;text-align:center;
      transition:border-color .15s,background .15s,box-shadow .15s;
      position:relative;display:flex;flex-direction:column;align-items:center;gap:6px;
    }
    .skt-pos-tile:hover{border-color:#111111;background:#fff;box-shadow:3px 3px 0 0 #FFD300;}
    .skt-pos-tile--active{
      border-color:#111111;background:#fff;
      box-shadow:3px 3px 0 0 #FFD300;
      border-left:3px solid #8400FF;
    }
    .skt-pos-tile__img{width:48px;height:48px;object-fit:cover;border-radius:7px;background:#efe8ff;display:block;}
    .skt-pos-tile__lbl{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:10.5px;
      letter-spacing:.06em;text-transform:uppercase;color:#6B7280;line-height:1;
    }
    .skt-pos-tile--active .skt-pos-tile__lbl{color:#111111;}
    .skt-pos-tile__check{
      position:absolute;top:5px;right:5px;
      width:16px;height:16px;background:#8400FF;border-radius:50%;
      display:none;align-items:center;justify-content:center;
    }
    .skt-pos-tile--active .skt-pos-tile__check{display:flex;}
    .skt-pos-tile__dot{
      position:absolute;bottom:5px;right:5px;
      width:7px;height:7px;border-radius:50%;
      background:#22C55E;border:1.5px solid #fff;display:none;
    }
    .skt-pos-tile--has .skt-pos-tile__dot{display:block;}
    .skt-pos-area-note{
      font-size:11.5px;color:#6B7280;
      background:#F4F4F6;padding:8px 12px;border-radius:8px;
      border-left:3px solid #FFD300;margin-top:4px;
    }
    .skt-pos-area-note strong{color:#111111;}

    /* ── Step 3 ── */
    .skt-step3-inner{display:flex;flex-direction:column;gap:10px;}
    #skt-step-3 [id^="skt-text-overlay-"]{display:none!important;}

    /* ── Step 3: subtitle ── */
    .skt-s3-subtitle{font-size:13px;color:#6B7280;margin:0 0 14px;line-height:1.5;}

    /* ── Step 3: card grid ── */
    .skt-s3-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px;}

    .skt-s3-card{
      background:#fff;border:2px solid #E5E7EB;border-radius:12px;
      padding:14px 16px;cursor:pointer;text-align:left;
      display:flex;align-items:center;gap:12px;
      transition:border-color .15s,box-shadow .15s,background .15s;
      outline:none;width:100%;
    }
    .skt-s3-card:hover{border-color:#111111;box-shadow:3px 3px 0 0 #FFD300;background:#fafafa;}
    .skt-s3-card:active{transform:translate(1px,1px);box-shadow:1px 1px 0 0 #FFD300;}
    .skt-s3-card--active{border-color:#111111!important;box-shadow:3px 3px 0 0 #FFD300!important;background:#fafafa!important;}
    .skt-s3-card--done{border-color:#22C55E!important;background:#f0fdf4!important;}
    .skt-s3-card--done:hover{border-color:#16a34a!important;box-shadow:3px 3px 0 0 #22C55E!important;}

    .skt-s3-card__icon{
      width:48px;height:48px;flex-shrink:0;
      display:flex;align-items:center;justify-content:center;
      background:#F4F4F6;border-radius:10px;
    }
    .skt-s3-card__icon--purple{background:#f0e6ff;}
    .skt-s3-card__icon--yellow{background:#fffbeb;}
    .skt-s3-card__icon--green{background:#f0fdf4;}

    .skt-s3-card__body{display:flex;flex-direction:column;gap:3px;min-width:0;flex:1;}
    .skt-s3-card__title{
      font-family:'Oswald',sans-serif;font-weight:700;font-size:13px;
      text-transform:uppercase;letter-spacing:.04em;color:#111111;line-height:1.2;
      display:block;
    }
    .skt-s3-card__title--accent{color:#8400FF;}
    .skt-s3-card__sub{font-size:11px;color:#6B7280;line-height:1.35;display:block;}
    .skt-s3-opt{font-family:inherit;font-weight:400;text-transform:none;letter-spacing:0;color:#aaa;font-size:11px;}

    /* ── Step 3: notes panel ── */
    .skt-s3-notes-panel{border:2px solid #E5E7EB;border-radius:12px;overflow:hidden;margin-top:4px;}
    .skt-s3-notes-hd{
      display:flex;align-items:center;gap:8px;padding:11px 16px;
      background:#F4F4F6;
      font-family:'Oswald',sans-serif;font-weight:700;font-size:12px;
      text-transform:uppercase;letter-spacing:.07em;color:#111111;
    }
    .skt-s3-notes-body{padding:12px 14px 14px;}
    #mrk-designer-notes{
      width:100%!important;box-sizing:border-box!important;
      border:2px solid #E5E7EB!important;border-radius:8px!important;
      padding:10px 12px!important;font-size:13px!important;
      color:#111!important;resize:vertical!important;
      min-height:72px!important;outline:none!important;
      font-family:inherit!important;line-height:1.5!important;
      background:#fff!important;
    }
    #mrk-designer-notes:focus{border-color:#111111!important;box-shadow:2px 2px 0 0 #FFD300!important;}

    /* ── Step 3: reassurance / trust panel ── */
    .skt-s3-trust{
      margin-top:14px;border:2px solid #111111;border-radius:12px;
      background:#fffbeb;overflow:hidden;
      box-shadow:3px 3px 0 0 #FFD300;
    }
    .skt-s3-trust__hd{
      display:flex;align-items:center;gap:8px;padding:9px 14px;
      background:#111111;color:#FFD300;
      font-family:'Oswald',sans-serif;font-weight:900;font-size:11px;
      text-transform:uppercase;letter-spacing:.08em;
    }
    .skt-s3-trust__list{
      list-style:none;padding:8px 14px 12px;margin:0;
    }
    .skt-s3-trust__list li{
      position:relative;padding:8px 0 8px 24px;
      font-size:12.5px;color:#374151;line-height:1.5;
    }
    .skt-s3-trust__list li:not(:last-child){
      border-bottom:1px solid rgba(17,17,17,.08);
    }
    .skt-s3-trust__list li::before{
      content:'';position:absolute;left:0;top:11px;
      width:15px;height:15px;border-radius:50%;background:#22C55E;
      background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='3.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
      background-position:center;background-repeat:no-repeat;
    }
    .skt-s3-trust__list li strong{color:#111111;font-weight:700;}

    /* ── Step 3: design library modal ── */
    #skt-lib-modal{position:fixed;inset:0;background:rgba(0,0,0,.72);z-index:999999;display:none;align-items:center;justify-content:center;padding:16px;}
    #skt-lib-modal.active{display:flex;}
    #skt-lib-box{background:#fff;border:2px solid #111;border-radius:16px;box-shadow:6px 6px 0 0 #FFD300;width:100%;max-width:520px;max-height:90vh;overflow:hidden;display:flex;flex-direction:column;}
    .skt-lib-hd{background:#111111;padding:14px 18px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
    .skt-lib-hd h3{font-family:'Oswald',sans-serif;font-weight:900;font-size:1rem;text-transform:uppercase;letter-spacing:.07em;color:#FFD300;margin:0;}
    .skt-lib-close{background:none;border:none;color:rgba(255,255,255,.55);font-size:1.4rem;cursor:pointer;line-height:1;padding:0 0 0 12px;transition:color .15s;}
    .skt-lib-close:hover{color:#fff;}
    .skt-lib-body{padding:16px;overflow-y:auto;}
    .skt-lib-cats{display:flex;gap:8px;margin-bottom:14px;flex-wrap:wrap;}
    .skt-lib-cat{padding:6px 14px;border:2px solid #E5E7EB;border-radius:20px;font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:#6B7280;cursor:pointer;background:#fff;transition:all .12s;}
    .skt-lib-cat--active,.skt-lib-cat:hover{border-color:#8400FF;color:#8400FF;background:#faf5ff;}
    .skt-lib-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
    .skt-lib-tile{border:2px solid #E5E7EB;border-radius:10px;overflow:hidden;cursor:pointer;transition:border-color .15s,box-shadow .15s;background:#F4F4F6;}
    .skt-lib-tile:hover{border-color:#8400FF;box-shadow:3px 3px 0 0 #FFD300;}
    .skt-lib-tile__preview{width:100%;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;font-size:36px;background:#F4F4F6;}
    .skt-lib-tile__lbl{font-family:'Oswald',sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#111;padding:6px 8px;text-align:center;background:#fff;border-top:1px solid #E5E7EB;}
    .skt-lib-coming{text-align:center;padding:28px 16px 8px;}
    .skt-lib-coming strong{color:#111;display:block;font-family:'Oswald',sans-serif;font-weight:900;font-size:.95rem;text-transform:uppercase;letter-spacing:.06em;margin-bottom:6px;}
    .skt-lib-coming p{font-size:12px;color:#6B7280;margin:0 0 16px;}

    /* ── Mobile: icon-top square tiles ── */
    @media(max-width:520px){
      .skt-s3-card{flex-direction:column;align-items:center;text-align:center;padding:14px 8px;gap:8px;}
      .skt-s3-card__body{align-items:center;}
      .skt-s3-card__sub{display:none;}
      .skt-s3-card__icon{width:44px;height:44px;}
      .skt-lib-grid{grid-template-columns:repeat(2,1fr);}
    }

    /* ── Step 4: size chart slot ── */
    .skt-step4-sg-slot{flex-shrink:0;margin-left:4px;display:none;}
    #skt-step-4.skt-step--active .skt-step4-sg-slot{display:block;}

    .skt-sg-btn{
      display:flex;flex-direction:column;align-items:center;justify-content:center;
      gap:2px;background:#111111;border:2px solid #111111;border-radius:8px;
      padding:6px 12px;cursor:pointer;color:#FFD300;
      transition:background .15s,box-shadow .15s,transform .1s;
      min-width:64px;line-height:1;box-shadow:2px 2px 0 0 #FFD300;
    }
    .skt-sg-btn:hover{background:#333;box-shadow:none;transform:translate(1px,1px);}
    .skt-sg-btn svg{stroke:#FFD300;transition:stroke .15s;}
    .skt-sg-btn__size{font-family:'Oswald',sans-serif;font-weight:900;font-size:11px;text-transform:uppercase;letter-spacing:.07em;color:#FFD300;}
    .skt-sg-btn__view{font-family:'Oswald',sans-serif;font-weight:600;font-size:8.5px;text-transform:uppercase;letter-spacing:.06em;color:rgba(255,211,0,.65);}

    /* ── Step 4: color row ── */
    #skt-sb-4-inner .mrk-color-row{background:#fff;border:2px solid #E5E7EB;border-radius:12px;overflow:hidden;margin-bottom:10px;}
    #skt-sb-4-inner .mrk-color-row__header{background:#111111;padding:10px 14px;display:flex;align-items:center;justify-content:space-between;}
    #skt-sb-4-inner .mrk-color-row__info{display:flex;align-items:center;gap:10px;}
    #skt-sb-4-inner .mrk-color-row__swatch{width:18px;height:18px;border-radius:50%;border:2px solid rgba(255,255,255,.35);flex-shrink:0;display:inline-block;}
    #skt-sb-4-inner .mrk-color-row__name{font-family:'Oswald',sans-serif;font-weight:700;font-size:13px;text-transform:uppercase;letter-spacing:.06em;color:#fff;}
    #skt-sb-4-inner .mrk-color-row__remove{background:none;border:1.5px solid rgba(255,255,255,.25);border-radius:4px;color:rgba(255,255,255,.55);font-size:14px;cursor:pointer;width:22px;height:22px;display:flex;align-items:center;justify-content:center;padding:0;transition:all .12s;}
    #skt-sb-4-inner .mrk-color-row__remove:hover{border-color:#EF4444;color:#EF4444;}

    /* ── Step 4: size grid ── */
    #skt-sb-4-inner .mrk-size-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(110px,1fr));gap:8px;padding:12px 12px 14px;}
    #skt-sb-4-inner .mrk-size-input{background:#F4F4F6;border:2px solid #E5E7EB;border-radius:10px;padding:10px 8px 8px;display:flex;flex-direction:column;align-items:center;gap:6px;transition:border-color .15s,box-shadow .15s;}
    #skt-sb-4-inner .mrk-size-input:focus-within{border-color:#111111;box-shadow:2px 2px 0 0 #FFD300;background:#fff;}
    #skt-sb-4-inner .mrk-size-input--unavailable{opacity:.45;}
    #skt-sb-4-inner .mrk-size-input__label{font-family:'Oswald',sans-serif;font-weight:900;font-size:14px;text-transform:uppercase;letter-spacing:.04em;color:#111111;line-height:1;}
    #skt-sb-4-inner .mrk-size-input__price{font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;color:#6B7280;}
    #skt-sb-4-inner .mrk-size-input__status{font-size:9.5px;color:#EF4444;font-weight:600;text-transform:uppercase;letter-spacing:.05em;}

    /* ── Step 4: ± buttons ── */
    .skt-qty-wrap{display:flex;align-items:center;gap:4px;}
    .skt-qty-btn{width:24px;height:24px;background:#fff;border:1.5px solid #111111;border-radius:5px;color:#111111;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700;line-height:1;transition:all .12s;user-select:none;flex-shrink:0;padding:0;}
    .skt-qty-btn:hover{background:#111111;color:#FFD300;border-color:#111111;}
    .skt-qty-btn:active{background:#000;border-color:#000;color:#FFD300;}
    .skt-qty-btn:disabled{opacity:.3;cursor:not-allowed;border-color:#E5E7EB;color:#ccc;}
    .skt-qty-btn:disabled:hover{background:#fff;color:#ccc;border-color:#E5E7EB;}
    .skt-qty-wrap .mrk-quantity-input{width:34px!important;height:24px!important;border:1.5px solid #E5E7EB!important;border-radius:5px!important;text-align:center!important;font-size:12px!important;font-family:'Oswald',sans-serif!important;font-weight:700!important;padding:0!important;background:#fff!important;color:#111!important;}
    .skt-qty-wrap .mrk-quantity-input:focus{border-color:#111111!important;outline:none!important;}

    /* ── Add Another Color button ── */
    #mrk-add-color-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;background:#111111!important;color:#FFD300!important;border:2px solid #111111!important;font-family:'Oswald',sans-serif!important;font-weight:700!important;font-size:0.8125rem!important;text-transform:uppercase!important;letter-spacing:.08em!important;padding:11px 20px!important;border-radius:6px!important;cursor:pointer!important;box-shadow:3px 3px 0 0 #FFD300!important;transition:background .15s,box-shadow .15s,transform .1s!important;margin-bottom:16px!important;}
    #mrk-add-color-btn:hover{background:#333!important;box-shadow:none!important;transform:translate(1px,1px)!important;}

    /* ── Subtotal bar (hidden — replaced by sticky bar) ── */
    #mrk-subtotal{display:none!important;}

    /* ── Sticky total bar ── */
    #skt-sticky-bar{position:sticky;bottom:12px;z-index:100;margin:16px 0 4px;}
    #skt-sticky-bar__inner{background:#111111;border:2px solid #111111;border-radius:14px;box-shadow:4px 4px 0 0 #FFD300;overflow:hidden;}
    #skt-sticky-bar__empty{display:flex;align-items:center;gap:10px;padding:13px 18px;}
    #skt-sticky-bar__empty-icon{width:30px;height:30px;border-radius:8px;background:rgba(255,255,255,.07);display:flex;align-items:center;justify-content:center;flex-shrink:0;}
    #skt-sticky-bar__empty-txt{font-family:'Oswald',sans-serif;font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.06em;color:rgba(255,255,255,.35);}
    #skt-sticky-bar__filled{display:none;flex-direction:column;}
    #skt-sticky-bar__top{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 18px 10px;border-bottom:1px solid rgba(255,255,255,.08);}
    #skt-sticky-bar__price{font-family:'Oswald',sans-serif;font-weight:900;font-size:1.6rem;color:#FFD300;line-height:1;}
    #skt-sticky-bar__price-cad{font-size:.75rem;font-weight:600;color:rgba(255,211,0,.6);margin-left:4px;}
    #skt-sticky-bar__meta{text-align:right;flex-shrink:0;}
    #skt-sticky-bar__ppi{font-family:'Oswald',sans-serif;font-size:12px;font-weight:700;color:rgba(255,255,255,.5);text-transform:uppercase;letter-spacing:.06em;}
    #skt-sticky-bar__save{display:none;margin-top:3px;background:#FFD300;color:#111111;font-family:'Oswald',sans-serif;font-weight:900;font-size:10px;text-transform:uppercase;letter-spacing:.05em;padding:2px 8px;border-radius:4px;}
    #skt-sticky-bar__no-art{display:none;align-items:center;gap:8px;padding:8px 18px;background:rgba(255,211,0,.06);border-top:1px solid rgba(255,211,0,.1);}
    #skt-sticky-bar__no-art-txt{font-family:'Oswald',sans-serif;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:rgba(255,211,0,.65);}
    #skt-sticky-bar__btn{display:block;margin:10px 14px 14px;background:#FFD300;color:#111111;border:2px solid #111111;border-radius:8px;padding:14px;font-family:'Oswald',sans-serif;font-weight:900;font-size:14px;text-transform:uppercase;letter-spacing:.08em;cursor:pointer;box-shadow:3px 3px 0 0 rgba(255,255,255,.1);width:calc(100% - 28px);transition:background .15s,opacity .15s,box-shadow .1s,transform .1s;}
    #skt-sticky-bar__btn:hover:not(:disabled){background:#ffc800;box-shadow:none;transform:translate(1px,1px);}
    #skt-sticky-bar__btn:disabled{opacity:.4;cursor:not-allowed;box-shadow:none;}

    /* ── Add to Cart button (hidden in step 4 — sticky bar handles it) ── */
    #mrk-submit-btn{display:none!important;}

    /* ── Bulk Pricing collapsible ── */
    .skt-price-breaks{margin-top:14px;border:2px solid #111111;border-radius:10px;overflow:hidden;box-shadow:3px 3px 0 0 #FFD300;}
    .skt-price-breaks__toggle{display:flex;align-items:center;justify-content:space-between;width:100%;padding:11px 16px;background:#111111;border:none;cursor:pointer;font-family:'Oswald',sans-serif;font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.08em;color:#FFD300;transition:background .15s;}
    .skt-price-breaks__toggle:hover{background:#222;}
    .skt-price-breaks__toggle-icon{transition:transform .2s;color:rgba(255,211,0,.6);font-style:normal;}
    .skt-price-breaks--open .skt-price-breaks__toggle-icon{transform:rotate(180deg);color:#FFD300;}
    .skt-price-breaks__body{display:none;padding:12px 14px 14px;background:#fff;border-top:2px solid #111111;}
    .skt-price-breaks--open .skt-price-breaks__body{display:block;}
    .skt-tier-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;}
    .skt-tier{background:#F4F4F6;border:2px solid #E5E7EB;border-radius:8px;padding:9px 10px;text-align:center;transition:all .15s;}
    .skt-tier--active{border-color:#111111;background:#111111;box-shadow:2px 2px 0 0 #FFD300;}
    .skt-tier__qty{font-family:'Oswald',sans-serif;font-weight:900;font-size:13px;color:#111111;line-height:1;margin-bottom:3px;}
    .skt-tier--active .skt-tier__qty{color:#FFD300;}
    .skt-tier__disc{font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;color:#6B7280;}
    .skt-tier--active .skt-tier__disc{color:rgba(255,211,0,.75);}
    .skt-price-breaks__note{font-size:11px;color:#6B7280;margin:10px 0 0;line-height:1.4;padding:8px 10px;background:#F4F4F6;border-radius:6px;border-left:3px solid #FFD300;}

    /* ── Hide original section shells ── */
    .skt-stepped{display:none!important;}

    /* ── Purple line fix ── */
    .mrk-cart-section{border-color:#fff!important;}

    /* ── Desktop layout: steps + sidebar ── */
    @media(min-width:900px){
      #skt-layout-wrap{display:flex;align-items:flex-start;gap:20px;}
      #skt-main-col{flex:1;min-width:0;}
      #skt-order-sidebar{width:290px;flex-shrink:0;position:sticky;top:80px;}
      #skt-sticky-bar{display:none!important;}
    }

    /* ── Order sidebar card ── */
    #skt-order-sidebar{display:none;}
    @media(min-width:900px){#skt-order-sidebar{display:block;}}
    .skt-os__card{background:#fff;border:2px solid #111111;border-radius:16px;overflow:hidden;box-shadow:4px 4px 0 0 #FFD300;}
    .skt-os__hd{background:#111111;padding:14px 18px;}
    .skt-os__hd-title{font-family:'Oswald',sans-serif;font-weight:900;font-size:1rem;text-transform:uppercase;letter-spacing:.07em;color:#FFD300;margin:0 0 2px;}
    .skt-os__hd-sub{font-size:11px;color:rgba(255,255,255,.45);}
    .skt-os__body{padding:14px 18px 0;}
    .skt-os__line{display:flex;align-items:center;justify-content:space-between;padding:9px 0;border-bottom:1px solid #F4F4F6;}
    .skt-os__line:last-of-type{border-bottom:none;}
    .skt-os__lbl{font-size:13px;color:#6B7280;}
    .skt-os__val{font-size:13px;font-weight:600;color:#111111;text-align:right;max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .skt-os__val--muted{color:#ccc!important;font-weight:400!important;}
    .skt-os__val--done{color:#16a34a!important;}
    .skt-os__total{display:flex;align-items:baseline;justify-content:space-between;padding:12px 18px;border-top:2px solid #F4F4F6;margin-top:4px;background:#F4F4F6;}
    .skt-os__total-lbl{font-family:'Oswald',sans-serif;font-weight:700;font-size:14px;text-transform:uppercase;letter-spacing:.06em;color:#111111;}
    .skt-os__total-price{font-family:'Oswald',sans-serif;font-weight:900;font-size:1.6rem;color:#111111;line-height:1;}
    .skt-os__total-price span{font-size:.7rem;font-weight:600;color:#6B7280;margin-left:3px;}
    .skt-os__btns{padding:0 14px 14px;display:flex;flex-direction:column;gap:8px;background:#fff;}
    .skt-os__cta{display:block;width:100%;background:#FFD300;color:#111111;border:2px solid #111111;border-radius:8px;padding:13px;font-family:'Oswald',sans-serif;font-weight:900;font-size:14px;text-transform:uppercase;letter-spacing:.08em;cursor:pointer;text-align:center;box-shadow:3px 3px 0 0 #111111;transition:background .15s,opacity .15s,box-shadow .1s,transform .1s;}
    .skt-os__cta:hover:not(:disabled){background:#111111;color:#FFD300;box-shadow:none;transform:translate(1px,1px);}
    .skt-os__cta:disabled{opacity:.4;cursor:not-allowed;box-shadow:none;}
    .skt-os__quote{display:block;width:100%;background:transparent;color:#6B7280;border:2px solid #E5E7EB;border-radius:8px;padding:10px;font-family:'Oswald',sans-serif;font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer;text-align:center;text-decoration:none;transition:border-color .15s,color .15s;}
    .skt-os__quote:hover{border-color:#111111;color:#111111;}
    .skt-os__trust{display:flex;flex-direction:column;gap:8px;padding:12px 18px 14px;border-top:2px solid #F4F4F6;background:#fff;}
    .skt-os__trust-row{display:flex;align-items:center;gap:10px;font-size:11px;color:#6B7280;line-height:1.4;}
    .skt-os__trust-icon{width:26px;height:26px;border-radius:7px;background:#F4F4F6;border:1px solid #E5E7EB;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:13px;}

    /* ── Mobile ── */
    @media(max-width:600px){
      #skt-steps-wrapper{gap:8px;margin-bottom:12px;}
      .skt-step{border-radius:12px;}
      .skt-step--active{box-shadow:3px 3px 0 0 #FFD300;}
      .skt-step__hd{padding:12px 14px;gap:10px;}
      .skt-step__bd{padding:12px 14px 16px;}
      .skt-step__label{font-size:13px;}
      .skt-step__num{width:30px;height:30px;font-size:13px;}
      .skt-step__preview{max-width:70px;font-size:10px;}
      #skt-step-1 button.skt-img-swatch{width:34px!important;height:34px!important;}
      #skt-step-1 #mrk-color-swatches{gap:7px!important;}
      .skt-pos-grid{grid-template-columns:repeat(2,1fr);gap:8px;}
      .skt-pos-tile__img{width:44px;height:44px;}
      .skt-pos-tile{padding:8px 6px;}
      .skt-qty-btn{width:20px;height:20px;font-size:13px;}
      .skt-qty-wrap{gap:3px;}
      .skt-qty-wrap .mrk-quantity-input{width:28px!important;height:20px!important;font-size:11px!important;}
      #skt-sb-4-inner .mrk-size-grid{grid-template-columns:repeat(3,1fr)!important;gap:5px!important;}
      #skt-sb-4-inner .mrk-size-input{padding:6px 4px!important;}
      #skt-sb-4-inner .mrk-size-input__label{font-size:12px!important;}
      .skt-tier-grid{grid-template-columns:repeat(2,1fr);}
      .skt-sg-btn{min-width:54px;padding:5px 8px;}
      .skt-sg-btn__size{font-size:10px;}
    }
  `;
const MRK = {
    product:null,colorSwatches:null,quantityBreaks:null,variantImages:null,config:null,
    selectedColor:null,selectedColorHex:null,selectedPosition:'front',
    selectedVariant:null,basePrice:null,
    artworks:{},activeArtwork:null,uploadedFiles:[],colorRows:[],
    mobileBarReady:false,$dom:{},_processing:false,
    _rmbgTargetPos:null,
    _activeStep:1,
    _stepsReady:false,

    init:function(){
      this.loadData();
      this.cacheDom();
      this.loadFromLocalStorage();
      this.renderColorSwatches();
      this.createStickyHeader();
      this.createMobileQuickBar();
      this.bindEvents();
      this.createStepLayout();
      this.initializeState();
    },

    loadData:function(){try{this.product=JSON.parse($('#mrk-product-data').text());this.colorSwatches=JSON.parse($('#mrk-color-swatches-data').text());this.quantityBreaks=JSON.parse($('#mrk-quantity-breaks-data').text());this.variantImages=JSON.parse($('#mrk-variant-images-data').text());this.config=JSON.parse($('#mrk-config-data').text());if(this.product?.variants?.length>0){const sm=this.product.variants.find(v=>v.option2==='SM'||v.option3==='SM');this.basePrice=sm?sm.price/100:this.product.variants[0].price/100;}}catch(e){console.error('MRK: loadData',e);}},

    cacheDom:function(){this.$dom={customizer:$('#mrk-customizer'),form:$('#mrk-customizer-form'),colorSwatches:$('#mrk-color-swatches'),selectedColorName:$('#mrk-selected-color-name'),positionButtons:$('#mrk-position-buttons'),uploadBtn:$('#mrk-upload-btn'),uploadPosition:$('.mrk-upload-position'),selectedFile:$('#mrk-selected-file'),changeFileBtn:$('#mrk-change-file-btn'),removeFileBtn:$('#mrk-remove-file-btn'),fileInput:$('#mrk-file-input'),designerNotes:$('#mrk-designer-notes'),addColorBtn:$('#mrk-add-color-btn'),colorRows:$('#mrk-color-rows'),totalItems:$('#mrk-total-items'),subtotal:$('#mrk-subtotal'),submitBtn:$('#mrk-submit-btn'),colorModal:$('#mrk-color-modal'),sizeGuideBtn:$('.mrk-size-guide-btn'),sizeGuideModal:$('#mrk-size-guide-modal'),modalSwatches:$('#mrk-modal-swatches'),fileModal:$('#mrk-file-modal'),fileLibrary:$('#mrk-file-library'),browseBtn:$('#mrk-browse-btn'),previewImage:$('#mrk-preview-image'),};},

    createStepLayout:function(){
      const self = this;
      $('head').append(`<style id="skt-steps-css">${SKT_STEPS_CSS}</style>`);

      const checkSVG = `<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>`;
      const chevSVG  = `<svg class="skt-step__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>`;

      const stepsHtml = `
        <div id="skt-steps-wrapper">
          <div class="skt-step skt-step--active" id="skt-step-1">
            <div class="skt-step__hd" data-step="1">
              <div class="skt-step__num" id="skt-num-1">1</div>
              <div class="skt-step__titles">
                <span class="skt-step__eyebrow">Step 1</span>
                <div class="skt-step__label">Select Color</div>
              </div>
              <div class="skt-step__preview" id="skt-sp-1"></div>
              ${chevSVG}
            </div>
            <div class="skt-step__bd" id="skt-sb-1">
              <div id="skt-sb-1-swatches"></div>
              <div class="skt-color-name-row">
                <span class="skt-cn-label">Selected:</span>
                <strong id="skt-step1-colorname">—</strong>
              </div>
            </div>
          </div>
          <div class="skt-step" id="skt-step-2">
            <div class="skt-step__hd" data-step="2">
              <div class="skt-step__num" id="skt-num-2">2</div>
              <div class="skt-step__titles">
                <span class="skt-step__eyebrow">Step 2</span>
                <div class="skt-step__label">Select Print Area</div>
              </div>
              <div class="skt-step__preview" id="skt-sp-2"></div>
              ${chevSVG}
            </div>
            <div class="skt-step__bd" id="skt-sb-2">
              <div class="skt-pos-grid" id="skt-pos-grid">
                <div class="skt-pos-tile skt-pos-tile--active" data-pos="front">
                  <img class="skt-pos-tile__img" id="skt-pt-img-front" src="" alt="Front">
                  <span class="skt-pos-tile__lbl">Front</span>
                  <span class="skt-pos-tile__check">${checkSVG}</span>
                  <span class="skt-pos-tile__dot"></span>
                </div>
                <div class="skt-pos-tile" data-pos="back">
                  <img class="skt-pos-tile__img" id="skt-pt-img-back" src="" alt="Back">
                  <span class="skt-pos-tile__lbl">Back</span>
                  <span class="skt-pos-tile__check">${checkSVG}</span>
                  <span class="skt-pos-tile__dot"></span>
                </div>
                <div class="skt-pos-tile" data-pos="left">
                  <img class="skt-pos-tile__img" id="skt-pt-img-left" src="" alt="Left Sleeve">
                  <span class="skt-pos-tile__lbl">L&nbsp;Sleeve</span>
                  <span class="skt-pos-tile__check">${checkSVG}</span>
                  <span class="skt-pos-tile__dot"></span>
                </div>
                <div class="skt-pos-tile" data-pos="right">
                  <img class="skt-pos-tile__img" id="skt-pt-img-right" src="" alt="Right Sleeve">
                  <span class="skt-pos-tile__lbl">R&nbsp;Sleeve</span>
                  <span class="skt-pos-tile__check">${checkSVG}</span>
                  <span class="skt-pos-tile__dot"></span>
                </div>
              </div>
              <div class="skt-pos-area-note">Adding a 2nd print area: <strong>+$8–$9 per print area</strong></div>
            </div>
          </div>
          <div class="skt-step" id="skt-step-3">
            <div class="skt-step__hd" data-step="3">
              <div class="skt-step__num" id="skt-num-3">3</div>
              <div class="skt-step__titles">
                <span class="skt-step__eyebrow">Step 3</span>
                <div class="skt-step__label">Add Your Design</div>
              </div>
              <div class="skt-step__preview" id="skt-sp-3"></div>
              ${chevSVG}
            </div>
            <div class="skt-step__bd" id="skt-sb-3">
              <div class="skt-step3-inner" id="skt-sb-3-inner"></div>
            </div>
          </div>
          <div class="skt-step" id="skt-step-4">
            <div class="skt-step__hd" data-step="4">
              <div class="skt-step__num" id="skt-num-4">4</div>
              <div class="skt-step__titles">
                <span class="skt-step__eyebrow">Step 4</span>
                <div class="skt-step__label">Quantity &amp; Sizes</div>
              </div>
              <div class="skt-step__preview" id="skt-sp-4"></div>
              <div class="skt-step4-sg-slot" id="skt-step4-sg-slot"></div>
              ${chevSVG}
            </div>
            <div class="skt-step__bd" id="skt-sb-4">
              <div id="skt-sb-4-inner"></div>
            </div>
          </div>
        </div>
      `;

      const $firstSection = this.$dom.customizer.find('.mrk-customizer__section').first();
      if($firstSection.length){
        $firstSection.before(stepsHtml);
      } else {
        this.$dom.form.before(stepsHtml);
      }

      this.$dom.colorSwatches.appendTo('#skt-sb-1-swatches');

      const $s3 = $('#skt-sb-3-inner');

      this.$dom.uploadBtn.appendTo($s3).hide();
      this.$dom.selectedFile.appendTo($s3).hide();

      if(this.product){
        const $to = $('#skt-text-overlay-'+String(this.product.id));
        if($to.length) $to.appendTo($s3);
      }

      const posLabelMap = {front:'Front',back:'Back',left:'Left Sleeve',right:'Right Sleeve'};
      const initPos = this.selectedPosition || 'front';
      const uploadIcon = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3" stroke="#111"/><path d="M8 12l4-4 4 4M12 8v8" stroke="#111"/></svg>`;
      const textIcon = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 7 4 4 20 4 20 7" stroke="#8400FF" stroke-width="1.8"/><line x1="9" y1="20" x2="15" y2="20" stroke="#8400FF" stroke-width="1.8"/><line x1="12" y1="4" x2="12" y2="20" stroke="#8400FF" stroke-width="1.8"/><path d="M16.5 17l2 2-3 .8.8-3z" fill="#FFD300" stroke="#FFD300" stroke-width="1"/></svg>`;
      const libIcon  = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><path d="M20 16.5l1.2 1.2L17.5 20l.8-3.7z" fill="#FFD300" stroke="#FFD300" stroke-width="1"/></svg>`;
      const notesIcon= `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="13" y2="12"/><path d="M15.5 15l2 2-3 .8.8-3z" fill="#FFD300" stroke="#FFD300" stroke-width="1"/></svg>`;

      $s3.prepend(`
        <p class="skt-s3-subtitle">Add text, upload artwork, or choose from our free design library.</p>
        <div class="skt-s3-grid" id="skt-s3-grid">
          <button type="button" class="skt-s3-card" id="skt-s3-btn-upload">
            <span class="skt-s3-card__icon">${uploadIcon}</span>
            <span class="skt-s3-card__body">
              <span class="skt-s3-card__title" id="skt-s3-upload-title">Upload Artwork for ${posLabelMap[initPos]||initPos}</span>
              <span class="skt-s3-card__sub">Upload your design file for the selected side</span>
            </span>
          </button>
          <button type="button" class="skt-s3-card" id="skt-s3-btn-text">
            <span class="skt-s3-card__icon skt-s3-card__icon--purple">${textIcon}</span>
            <span class="skt-s3-card__body">
              <span class="skt-s3-card__title skt-s3-card__title--accent" id="skt-s3-text-title">Add Text for ${posLabelMap[initPos]||initPos}</span>
              <span class="skt-s3-card__sub">Insert your custom text</span>
            </span>
          </button>
          <button type="button" class="skt-s3-card" id="skt-s3-btn-library">
            <span class="skt-s3-card__icon skt-s3-card__icon--yellow">${libIcon}</span>
            <span class="skt-s3-card__body">
              <span class="skt-s3-card__title">Browse Free Designs</span>
              <span class="skt-s3-card__sub">Choose from our free design templates</span>
            </span>
          </button>
          <button type="button" class="skt-s3-card" id="skt-s3-btn-notes">
            <span class="skt-s3-card__icon">${notesIcon}</span>
            <span class="skt-s3-card__body">
              <span class="skt-s3-card__title">Notes for Designer</span>
              <span class="skt-s3-card__sub">Provide instructions or requests</span>
            </span>
          </button>
        </div>
        <div class="skt-s3-trust">
          <div class="skt-s3-trust__hd">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
            What happens next
          </div>
          <ul class="skt-s3-trust__list">
            <li><strong>Free mock-up before we print.</strong> You approve every detail first.</li>
            <li><strong>Got a background you don't want?</strong> We'll remove it for free.</li>
            <li><strong>Upload anything: a screenshot, sketch, or inspiration pic.</strong> We'll make it print-ready.</li>
          </ul>
        </div>
        <div class="skt-s3-notes-panel" id="skt-s3-notes-panel" style="display:none">
          <div class="skt-s3-notes-hd">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="13" y2="12"/></svg>
            Designer Notes <span class="skt-s3-opt" style="margin-left:4px;">(optional)</span>
          </div>
          <div class="skt-s3-notes-body" id="skt-s3-notes-body"></div>
        </div>
      `);

      if(this.$dom.designerNotes.length){
        this.$dom.designerNotes
          .attr('placeholder','Add instructions like size, placement, colors, etc.')
          .appendTo('#skt-s3-notes-body');
      }

      $('#skt-s3-btn-upload').on('click', function(){ self.openFileModal(); });
      $('#skt-s3-btn-text').on('click', function(){
        const t = document.querySelector('.skt-trigger-btn');
        if(t){ $(t).trigger('click'); return; }
        if(typeof sktOpenModal==='function' && self.product) sktOpenModal(String(self.product.id));
      });
      $('#skt-s3-btn-library').on('click', function(){ self.openDesignLibrary(); });
      $('#skt-s3-btn-notes').on('click', function(){
        const $p = $('#skt-s3-notes-panel');
        const open = $p.is(':visible');
        $p.slideToggle(160);
        $('#skt-s3-btn-notes').toggleClass('skt-s3-card--active', !open);
        if(!open) setTimeout(()=>{ self.$dom.designerNotes[0]?.focus(); }, 200);
      });

      const $s4 = $('#skt-sb-4-inner');
      if(this.$dom.addColorBtn.length) this.$dom.addColorBtn.appendTo($s4);
      this.$dom.colorRows.appendTo($s4);
      this.$dom.subtotal.appendTo($s4);
      this.$dom.submitBtn.appendTo($s4);

      const tierRows = DISCOUNT_TIERS.map(t=>{
        const label = t.max===Infinity ? `${t.min}+` : `${t.min}–${t.max}`;
        const disc = t.discount > 0 ? `${(t.discount*100).toFixed(0)}% off` : 'Base price';
        return `<div class="skt-tier" data-min="${t.min}" data-max="${t.max===Infinity?99999:t.max}">
          <div class="skt-tier__qty">${label}</div>
          <div class="skt-tier__disc">${disc}</div>
        </div>`;
      }).join('');
      $s4.append(`
        <div class="skt-price-breaks" id="skt-price-breaks">
          <button type="button" class="skt-price-breaks__toggle">
            <span>💰 Bulk Pricing</span>
            <em class="skt-price-breaks__toggle-icon">▼</em>
          </button>
          <div class="skt-price-breaks__body">
            <div class="skt-tier-grid">${tierRows}</div>
            <div class="skt-price-breaks__note">Discount applied automatically at checkout. Prices shown per item reflect your active tier.</div>
          </div>
        </div>
      `);

      $(document).on('click','#skt-price-breaks .skt-price-breaks__toggle',function(){
        $('#skt-price-breaks').toggleClass('skt-price-breaks--open');
      });

      const $sgSlot = $('#skt-step4-sg-slot');
      $sgSlot.html(`
        <button type="button" id="skt-sg-btn" class="skt-sg-btn">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 20 L20 20 L20 4 L2 20 Z"/>
            <line x1="7"  y1="20" x2="7"  y2="17"/>
            <line x1="12" y1="20" x2="12" y2="15"/>
            <line x1="16" y1="20" x2="16" y2="12"/>
            <line x1="20" y1="11" x2="17" y2="11"/>
            <line x1="20" y1="15" x2="16" y2="15"/>
          </svg>
          <span class="skt-sg-btn__size">SIZE</span>
          <span class="skt-sg-btn__view">VIEW CHART</span>
        </button>
      `);
      $(document).on('click','#skt-sg-btn',function(e){
        e.stopPropagation();
        var $psModal = $('[id^="skt-size-modal-"]').first();
        if($psModal.length){ $psModal[0].classList.add('open'); }
        else { self.$dom.sizeGuideModal.addClass('mrk-modal--active'); }
      });

      this.$dom.customizer.find('.mrk-customizer__section').addClass('skt-stepped');
      this.$dom.customizer.find('[id*="sizes"],[id*="quantity"],[id*="qty"],[class*="sizes"],[class*="quantity-section"],[class*="qty-section"]').addClass('skt-stepped');

      this.$dom.totalItems.parents().each(function(){
        const $p = $(this);
        const id  = ($p.attr('id')  || '').toLowerCase();
        const cls = ($p.attr('class') || '').toLowerCase();
        if($p.is('#mrk-customizer,#mrk-customizer-form,body,html,[id="skt-steps-wrapper"]')) return false;
        if((id+cls).match(/total|subtotal|summary|order|cart-info/)){
          $p.addClass('skt-stepped');
          return false;
        }
      });
      $('head').append('<style>.mrk-totals-bar,.mrk-order-summary,.mrk-cart-totals,[class*="mrk-totals"]{display:none!important;}</style>');

      $(document).on('click','#skt-steps-wrapper .skt-step__hd',function(){
        const n = parseInt($(this).data('step'));
        self.openStep(n);
      });

      $('#skt-pos-grid').on('click','.skt-pos-tile',function(){
        const pos = $(this).data('pos');
        self.selectPosition(pos);
      });

      this._stepsReady = true;

      // ── Sticky total bar ─────────────────────────────────────────────────
      const warnIcon=`<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,211,0,.7)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`;
      const cartIcon=`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`;
      const addIcon=`<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>`;
      $('#skt-steps-wrapper').after(`
        <div id="skt-sticky-bar">
          <div id="skt-sticky-bar__inner">
            <div id="skt-sticky-bar__empty">
              <div id="skt-sticky-bar__empty-icon">${addIcon}</div>
              <span id="skt-sticky-bar__empty-txt">Add artwork &amp; qty to see total</span>
            </div>
            <div id="skt-sticky-bar__filled">
              <div id="skt-sticky-bar__top">
                <div id="skt-sticky-bar__price">$0.00 <span id="skt-sticky-bar__price-cad">CAD</span></div>
                <div id="skt-sticky-bar__meta">
                  <div id="skt-sticky-bar__ppi">—</div>
                  <div id="skt-sticky-bar__save"></div>
                </div>
              </div>
              <div id="skt-sticky-bar__no-art">${warnIcon}<span id="skt-sticky-bar__no-art-txt">Upload artwork or add text to continue</span></div>
              <button type="button" id="skt-sticky-bar__btn" disabled>${cartIcon} &nbsp;Add to Cart</button>
            </div>
          </div>
        </div>
      `);
      $(document).on('click','#skt-sticky-bar__btn',function(){ if(!$(this).prop('disabled')) self.addToCart(); });

      // hide original submit button (sticky bar handles it)
      this.$dom.submitBtn.hide();

      // ── Desktop order sidebar ─────────────────────────────────────────────
      $('#skt-steps-wrapper').add('#skt-sticky-bar').wrapAll('<div id="skt-main-col"></div>');
      $('#skt-main-col').wrap('<div id="skt-layout-wrap"></div>');
      $('#skt-layout-wrap').append(`
        <div id="skt-order-sidebar">
          <div class="skt-os__card">
            <div class="skt-os__hd">
              <div class="skt-os__hd-title">Your Order</div>
              <div class="skt-os__hd-sub">Review before adding to cart</div>
            </div>
            <div class="skt-os__body">
              <div class="skt-os__line">
                <span class="skt-os__lbl">Colour</span>
                <span class="skt-os__val skt-os__val--muted" id="skt-os-colour">Not selected</span>
              </div>
              <div class="skt-os__line">
                <span class="skt-os__lbl">Print Area</span>
                <span class="skt-os__val skt-os__val--muted" id="skt-os-area">Front</span>
              </div>
              <div class="skt-os__line">
                <span class="skt-os__lbl">Design</span>
                <span class="skt-os__val skt-os__val--muted" id="skt-os-design">Not uploaded</span>
              </div>
              <div class="skt-os__line">
                <span class="skt-os__lbl">Total Items</span>
                <span class="skt-os__val skt-os__val--muted" id="skt-os-qty">0</span>
              </div>
              <div class="skt-os__line">
                <span class="skt-os__lbl">Price / Shirt</span>
                <span class="skt-os__val" id="skt-os-ppi">—</span>
              </div>
            </div>
            <div class="skt-os__total">
              <span class="skt-os__total-lbl">Subtotal</span>
              <span class="skt-os__total-price" id="skt-os-subtotal">$0.00 <span>CAD</span></span>
            </div>
            <div class="skt-os__btns">
              <button type="button" class="skt-os__cta" id="skt-os-btn" disabled>Add to Cart →</button>
            </div>
            <div class="skt-os__trust">
              <div class="skt-os__trust-row"><div class="skt-os__trust-icon">⚡</div>3-4 business day turnaround in Saskatoon</div>
              <div class="skt-os__trust-row"><div class="skt-os__trust-icon">🎨</div>Free design review before printing</div>
              <div class="skt-os__trust-row"><div class="skt-os__trust-icon">✌</div>No minimums - order just one shirt</div>
              <div class="skt-os__trust-row"><div class="skt-os__trust-icon">📍</div>Printed in Brighton, Saskatoon</div>
            </div>
          </div>
        </div>
      `);
      $(document).on('click','#skt-os-btn',function(){ if(!$(this).prop('disabled')) self.addToCart(); });
    },
updateOrderSidebar:function(){
      if(!this._stepsReady) return;
      const $col = $('#skt-os-colour');
      if(this.selectedColor){$col.text(this.selectedColor).removeClass('skt-os__val--muted');}
      else{$col.text('Not selected').addClass('skt-os__val--muted');}
      const areaMap = {front:'Front',back:'Back',left:'Left Sleeve',right:'Right Sleeve'};
      $('#skt-os-area').text(areaMap[this.selectedPosition]||this.selectedPosition).removeClass('skt-os__val--muted');
      const $des = $('#skt-os-design');
      const areas = Object.keys(this.artworks);
      if(areas.length === 0){$des.text('Not uploaded').addClass('skt-os__val--muted').removeClass('skt-os__val--done');}
      else{const labels = areas.map(p => {const art = this.artworks[p];return (areaMap[p]||p) + (art.isTextDesign ? ' (text)' : ' ✓');});$des.text(labels.join(', ')).removeClass('skt-os__val--muted').addClass('skt-os__val--done');}
      let total = 0;
      this.colorRows.forEach(r => Object.keys(r.sizes).forEach(s => { total += (r.sizes[s].quantity||0); }));
      const $qty = $('#skt-os-qty');
      if(total > 0){ $qty.text(total).removeClass('skt-os__val--muted'); }
      else { $qty.text('0').addClass('skt-os__val--muted'); }
      const disc = this.getDiscountTier(total);
      const ps = getPrintSurcharge(total);
      let sub = 0;
      this.colorRows.forEach(r => Object.keys(r.sizes).forEach(s => {
        const q = r.sizes[s].quantity||0;
        if(q > 0){ const bp=r.sizes[s].price,pc=areas.length>1?(areas.length-1)*ps:0; sub+=q*(bp*(1-disc)+pc); }
      }));
      const ppi = total > 0 ? (sub/total) : this.basePrice||0;
      $('#skt-os-ppi').text('$'+ppi.toFixed(2));
      $('#skt-os-subtotal').html('$'+sub.toFixed(2)+' <span>CAD</span>');
      const $btn = $('#skt-os-btn');
      if(total > 0 && areas.length > 0){$btn.prop('disabled', false).text('Add to Cart →');}
      else if(total > 0 && areas.length === 0){$btn.prop('disabled', true).text('Upload Artwork to Continue');}
      else{$btn.prop('disabled', true).text('Add to Cart →');}
    },

    updateStickyBar:function(){
      if(!this._stepsReady) return;
      let total=0;
      this.colorRows.forEach(r=>Object.keys(r.sizes).forEach(s=>{total+=(r.sizes[s].quantity||0);}));
      const areas=Object.keys(this.artworks).length;
      const hasArt=areas>0;
      const $empty=$('#skt-sticky-bar__empty');
      const $filled=$('#skt-sticky-bar__filled');
      if(total===0){$empty.show();$filled.hide();return;}
      $empty.hide();$filled.css('display','flex');
      const disc=this.getDiscountTier(total);
      const ps=getPrintSurcharge(total);
      let sub=0;
      this.colorRows.forEach(r=>Object.keys(r.sizes).forEach(s=>{
        const q=r.sizes[s].quantity||0;
        if(q>0){const bp=r.sizes[s].price,pc=areas>1?(areas-1)*ps:0;sub+=q*(bp*(1-disc)+pc);}
      }));
      const ppi=total>0?(sub/total):0;
      const orig=this.colorRows.reduce((a,r)=>a+Object.keys(r.sizes).reduce((b,s)=>b+(r.sizes[s].quantity||0)*r.sizes[s].price,0),0);
      const save=orig-sub;
      $('#skt-sticky-bar__price').html('$'+sub.toFixed(2)+' <span id="skt-sticky-bar__price-cad">CAD</span>');
      $('#skt-sticky-bar__ppi').text('$'+ppi.toFixed(2)+'/item \xB7 '+total+' item'+(total!==1?'s':''));
      const $save=$('#skt-sticky-bar__save');
      if(disc>0&&save>0.01){$save.text('SAVE $'+save.toFixed(2)).show();}else{$save.hide();}
      const $noArt=$('#skt-sticky-bar__no-art');
      const $btn=$('#skt-sticky-bar__btn');
      if(!hasArt){$noArt.css('display','flex');$btn.prop('disabled',true).html('Upload Artwork or Add Text to Continue');}
      else{$noArt.hide();$btn.prop('disabled',false).html('<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to Cart');}
    },

    updateStep3State:function(){
      if(!this._stepsReady) return;
      const posLabelMap = {front:'Front',back:'Back',left:'L Sleeve',right:'R Sleeve'};
      const areas = Object.keys(this.artworks);
      if(areas.length > 0){
        this.markStepDone(3);
        const labels = areas.map(p => posLabelMap[p] || p);
        this.updateStepPreview(3, labels.join(', '));
      } else {
        $('#skt-step-3').removeClass('skt-step--done');
        $('#skt-num-3').text('3');
        this.updateStepPreview(3, '');
      }
    },

    updateStep3Cards:function(){
      if(!this._stepsReady) return;
      const posLabelMap = {front:'Front',back:'Back',left:'Left Sleeve',right:'Right Sleeve'};
      const pos = this.selectedPosition || 'front';
      const label = posLabelMap[pos] || pos;
      const hasArt = this.artworks[pos] && !this.artworks[pos].isTextDesign;
      $('#skt-s3-upload-title').text((hasArt?'Change':'Upload')+' Artwork for '+label);
      $('#skt-s3-text-title').text('Add Text for '+label);
      $('#skt-s3-btn-upload').toggleClass('skt-s3-card--done', !!hasArt);
    },

    openDesignLibrary:function(){
      const self=this;
      let data={categories:[],designs:[]};
      try{const dataEl=document.getElementById('skt-free-designs-data');if(dataEl)data=JSON.parse(dataEl.textContent);}catch(e){console.warn('[SKT] free designs data parse failed:',e);}
      if(!$('#skt-flib-css').length){
        $('head').append(`<style id="skt-flib-css">
          #skt-flib-modal{position:fixed;inset:0;background:rgba(0,0,0,.72);z-index:999999;display:none;align-items:center;justify-content:center;padding:16px;}
          #skt-flib-modal.active{display:flex;}
          #skt-flib-box{background:#fff;border:2px solid #111;border-radius:16px;box-shadow:6px 6px 0 0 #FFD300;width:100%;max-width:620px;max-height:90vh;overflow:hidden;display:flex;flex-direction:column;}
          .skt-flib-hd{background:#111111;padding:14px 18px;display:flex;align-items:center;gap:12px;flex-shrink:0;}
          .skt-flib-hd__title{font-family:'Oswald',sans-serif;font-weight:900;font-size:1rem;text-transform:uppercase;letter-spacing:.07em;color:#FFD300;margin:0;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
          .skt-flib-hd__back{background:none;border:1.5px solid rgba(255,255,255,.25);border-radius:6px;color:#FFD300;font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.06em;padding:5px 10px;cursor:pointer;display:none;align-items:center;gap:4px;flex-shrink:0;transition:all .12s;}
          .skt-flib-hd__back:hover{border-color:#FFD300;background:rgba(255,211,0,.1);}
          .skt-flib-hd__back--show{display:inline-flex;}
          .skt-flib-close{background:none;border:none;color:rgba(255,255,255,.55);font-size:1.4rem;cursor:pointer;line-height:1;padding:0 0 0 8px;transition:color .15s;flex-shrink:0;}
          .skt-flib-close:hover{color:#fff;}
          .skt-flib-search-wrap{padding:12px 16px 0;flex-shrink:0;}
          .skt-flib-search{width:100%;box-sizing:border-box;border:2px solid #E5E7EB;border-radius:8px;padding:9px 12px 9px 36px;font-size:13px;color:#111;outline:none;background:#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E") no-repeat 12px center;font-family:inherit;}
          .skt-flib-search:focus{border-color:#111111;box-shadow:2px 2px 0 0 #FFD300;}
          .skt-flib-body{padding:14px 16px 16px;overflow-y:auto;flex:1;-webkit-overflow-scrolling:touch;}
          .skt-flib-empty{text-align:center;padding:40px 16px;color:#6B7280;font-size:13px;line-height:1.6;}
          .skt-flib-empty strong{display:block;font-family:'Oswald',sans-serif;font-weight:900;color:#111;font-size:14px;margin-bottom:6px;text-transform:uppercase;letter-spacing:.06em;}
          .skt-flib-cat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
          .skt-flib-cat-tile{border:2px solid #E5E7EB;border-radius:12px;background:#fff;cursor:pointer;padding:18px 8px 14px;display:flex;flex-direction:column;align-items:center;gap:7px;transition:border-color .12s,box-shadow .12s,transform .08s;text-align:center;}
          .skt-flib-cat-tile:hover{border-color:#111111;box-shadow:3px 3px 0 0 #FFD300;}
          .skt-flib-cat-tile:active{transform:translate(1px,1px);box-shadow:1px 1px 0 0 #FFD300;}
          .skt-flib-cat-tile__emoji{font-size:32px;line-height:1;}
          .skt-flib-cat-tile__name{font-family:'Oswald',sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.05em;color:#111;line-height:1.2;}
          .skt-flib-cat-tile__count{font-family:'Oswald',sans-serif;font-weight:600;font-size:9px;color:#8400FF;text-transform:uppercase;letter-spacing:.06em;}
          .skt-flib-design-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
          .skt-flib-design-tile{border:2px solid #E5E7EB;border-radius:10px;overflow:hidden;cursor:pointer;background:#F4F4F6;transition:border-color .12s,box-shadow .12s,transform .08s;display:flex;flex-direction:column;}
          .skt-flib-design-tile:hover{border-color:#111111;box-shadow:3px 3px 0 0 #FFD300;}
          .skt-flib-design-tile:active{transform:translate(1px,1px);box-shadow:1px 1px 0 0 #FFD300;}
          .skt-flib-design-tile__img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff;display:block;padding:8px;box-sizing:border-box;}
          .skt-flib-design-tile__img--light{background:#fff;}
          .skt-flib-design-tile__img--dark{background:#111;}
          .skt-flib-design-tile__lbl{font-family:'Oswald',sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:#111;padding:6px 8px;text-align:center;background:#fff;border-top:1px solid #E5E7EB;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
          .skt-flib-search-meta{font-size:11px;color:#6B7280;margin:0 0 10px;font-family:'Oswald',sans-serif;font-weight:600;text-transform:uppercase;letter-spacing:.06em;}
          #skt-flib-preview{position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:9999999;display:none;align-items:center;justify-content:center;padding:20px;}
          #skt-flib-preview.active{display:flex;}
          #skt-flib-preview-box{background:#fff;border:2px solid #111;border-radius:16px;box-shadow:6px 6px 0 0 #FFD300;width:100%;max-width:480px;max-height:92vh;overflow:hidden;display:flex;flex-direction:column;}
          .skt-flib-pv-hd{background:#111111;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
          .skt-flib-pv-hd h3{font-family:'Oswald',sans-serif;font-weight:900;font-size:.9rem;text-transform:uppercase;letter-spacing:.06em;color:#FFD300;margin:0;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
          .skt-flib-pv-close{background:none;border:none;color:rgba(255,255,255,.55);font-size:1.4rem;cursor:pointer;line-height:1;padding:0 0 0 10px;transition:color .15s;flex-shrink:0;}
          .skt-flib-pv-close:hover{color:#fff;}
          .skt-flib-pv-body{padding:16px;display:flex;flex-direction:column;gap:12px;overflow-y:auto;}
          .skt-flib-pv-img-wrap{width:100%;aspect-ratio:1/1;max-height:340px;background:#fff;border:2px solid #E5E7EB;border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:14px;box-sizing:border-box;}
          .skt-flib-pv-img-wrap--light{background:#fff;border-color:#E5E7EB;}
          .skt-flib-pv-img-wrap--dark{background:#111;border-color:#111;}
          .skt-flib-pv-img-wrap img{max-width:100%;max-height:100%;object-fit:contain;display:block;}
          .skt-flib-pv-meta{font-size:12px;color:#6B7280;line-height:1.5;padding:0 4px;}
          .skt-flib-pv-meta strong{color:#111;font-family:'Oswald',sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:.05em;font-size:11px;display:block;margin-bottom:3px;}
          .skt-flib-pv-actions{display:flex;gap:8px;padding:12px 16px 16px;background:#F4F4F6;border-top:2px solid #E5E7EB;flex-shrink:0;}
          .skt-flib-pv-btn{flex:1;padding:13px 14px;border:2px solid #111111;border-radius:8px;font-family:'Oswald',sans-serif;font-weight:900;font-size:12px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer;transition:background .15s,box-shadow .1s,transform .1s;}
          .skt-flib-pv-btn--apply{background:#FFD300;color:#111;box-shadow:3px 3px 0 0 #111;}
          .skt-flib-pv-btn--apply:hover{background:#ffc800;box-shadow:none;transform:translate(1px,1px);}
          .skt-flib-pv-btn--cancel{background:#fff;color:#111;flex:0 0 auto;padding:13px 18px;}
          .skt-flib-pv-btn--cancel:hover{background:#F4F4F6;}
          @media(max-width:520px){
            .skt-flib-cat-grid{grid-template-columns:repeat(2,1fr);}
            .skt-flib-design-grid{grid-template-columns:repeat(2,1fr);}
            .skt-flib-cat-tile__emoji{font-size:28px;}
          }
        </style>`);
      }
      if(!$('#skt-flib-modal').length){
        $('body').append(`<div id="skt-flib-modal">
          <div id="skt-flib-box">
            <div class="skt-flib-hd">
              <button type="button" class="skt-flib-hd__back" id="skt-flib-back">← Categories</button>
              <h3 class="skt-flib-hd__title" id="skt-flib-title">🎨 Free Design Library</h3>
              <button type="button" class="skt-flib-close" id="skt-flib-close">✕</button>
            </div>
            <div class="skt-flib-search-wrap">
              <input type="text" class="skt-flib-search" id="skt-flib-search" placeholder="Search designs..." autocomplete="off">
            </div>
            <div class="skt-flib-body" id="skt-flib-body"></div>
          </div>
        </div>
        <div id="skt-flib-preview">
          <div id="skt-flib-preview-box">
            <div class="skt-flib-pv-hd">
              <h3 id="skt-flib-pv-title">Design</h3>
              <button type="button" class="skt-flib-pv-close" id="skt-flib-pv-close">✕</button>
            </div>
            <div class="skt-flib-pv-body">
              <div class="skt-flib-pv-img-wrap"><img id="skt-flib-pv-img" src="" alt=""></div>
              <div class="skt-flib-pv-meta" id="skt-flib-pv-meta"></div>
            </div>
            <div class="skt-flib-pv-actions">
              <button type="button" class="skt-flib-pv-btn skt-flib-pv-btn--cancel" id="skt-flib-pv-cancel">Cancel</button>
              <button type="button" class="skt-flib-pv-btn skt-flib-pv-btn--apply" id="skt-flib-pv-apply">Apply to Shirt →</button>
            </div>
          </div>
        </div>`);
        let viewState={mode:'categories',categoryId:null,searchTerm:''};
        let pendingDesign=null;
        const escapeHtml=function(s){return String(s||'').replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});};
        const renderCategories=function(){
          viewState.mode='categories';viewState.categoryId=null;
          $('#skt-flib-title').text('🎨 Free Design Library');
          $('#skt-flib-back').removeClass('skt-flib-hd__back--show');
          const cats=(data.categories||[]).slice().sort((a,b)=>(a.sort_order||999)-(b.sort_order||999));
          const designs=data.designs||[];
          if(cats.length===0){
            $('#skt-flib-body').html('<div class="skt-flib-empty"><strong>Library coming soon</strong>Categories will appear here once they are set up.</div>');
            return;
          }
          let html='<div class="skt-flib-cat-grid">';
          cats.forEach(function(c){
            const count=designs.filter(d=>d.category_id===c.id).length;
            html+=`<div class="skt-flib-cat-tile" data-cat-id="${escapeHtml(c.id)}">
              <span class="skt-flib-cat-tile__emoji">${escapeHtml(c.emoji||'🎨')}</span>
              <span class="skt-flib-cat-tile__name">${escapeHtml(c.name)}</span>
              <span class="skt-flib-cat-tile__count">${count} design${count!==1?'s':''}</span>
            </div>`;
          });
          html+='</div>';
          $('#skt-flib-body').html(html);
        };
        const renderCategoryDesigns=function(catId){
          viewState.mode='category';viewState.categoryId=catId;
          const cat=(data.categories||[]).find(c=>c.id===catId);
          $('#skt-flib-title').text((cat?cat.emoji+' '+cat.name:'Designs'));
          $('#skt-flib-back').addClass('skt-flib-hd__back--show');
          const designs=(data.designs||[]).filter(d=>d.category_id===catId&&d.image_url).sort((a,b)=>(a.sort_order||999)-(b.sort_order||999));
          if(designs.length===0){
            $('#skt-flib-body').html('<div class="skt-flib-empty"><strong>No designs yet</strong>Check back soon — designs for this category are on the way.</div>');
            return;
          }
          renderDesignGrid(designs);
        };
        const renderSearchResults=function(term){
          viewState.mode='search';
          const q=term.toLowerCase().trim();
          const designs=(data.designs||[]).filter(function(d){
            if(!d.image_url)return false;
            const inName=(d.name||'').toLowerCase().includes(q);
            const inTags=(d.tags||[]).some(t=>(t||'').toLowerCase().includes(q));
            return inName||inTags;
          });
          $('#skt-flib-title').text('Search Results');
          $('#skt-flib-back').addClass('skt-flib-hd__back--show');
          let html='<p class="skt-flib-search-meta">'+designs.length+' result'+(designs.length!==1?'s':'')+' for "'+escapeHtml(term)+'"</p>';
          if(designs.length===0){
            html+='<div class="skt-flib-empty"><strong>Nothing matching that search</strong>Try a different word, or browse by category.</div>';
            $('#skt-flib-body').html(html);
            return;
          }
          $('#skt-flib-body').html(html);
          renderDesignGrid(designs,true);
        };
        const renderDesignGrid=function(designs,append){
          let html='<div class="skt-flib-design-grid">';
          designs.forEach(function(d){
            const thumb=d.image_thumb||d.image_url;
            const bgCls=d.dark_background?'skt-flib-design-tile__img--dark':'skt-flib-design-tile__img--light';
            html+=`<div class="skt-flib-design-tile" data-design-id="${escapeHtml(d.id)}">
              <img class="skt-flib-design-tile__img ${bgCls}" src="${escapeHtml(thumb)}" alt="${escapeHtml(d.name)}" loading="lazy">
              <div class="skt-flib-design-tile__lbl">${escapeHtml(d.name)}</div>
            </div>`;
          });
          html+='</div>';
          if(append){$('#skt-flib-body').append(html);}else{$('#skt-flib-body').html(html);}
        };
        const showPreview=function(designId){
          const d=(data.designs||[]).find(x=>x.id===designId);
          if(!d){return;}
          pendingDesign=d;
          const cat=(data.categories||[]).find(c=>c.id===d.category_id);
          $('#skt-flib-pv-title').text(d.name||'Design');
          $('#skt-flib-pv-img').attr('src',d.image_url||d.image_thumb||'').attr('alt',d.name||'');
          $('#skt-flib-pv-img').closest('.skt-flib-pv-img-wrap').removeClass('skt-flib-pv-img-wrap--dark skt-flib-pv-img-wrap--light').addClass(d.dark_background?'skt-flib-pv-img-wrap--dark':'skt-flib-pv-img-wrap--light');
          let metaHtml='';
          if(cat){metaHtml+='<strong>Category</strong>'+escapeHtml(cat.emoji||'')+' '+escapeHtml(cat.name)+'<br><br>';}
          if(d.tags&&d.tags.length){metaHtml+='<strong>Tags</strong>'+d.tags.map(escapeHtml).join(', ');}
          if(!metaHtml){metaHtml='<em style="color:#aaa;">Tap "Apply to Shirt" to add this design to your current print area.</em>';}
          $('#skt-flib-pv-meta').html(metaHtml);
          $('#skt-flib-preview').addClass('active');
        };
        const closePreview=function(){$('#skt-flib-preview').removeClass('active');pendingDesign=null;};
        const applyDesign=function(){
          if(!pendingDesign||!pendingDesign.image_url){closePreview();return;}
          const url=pendingDesign.image_url;
          const safeName=(pendingDesign.name||'design').replace(/[^a-z0-9_\- ]/gi,'').trim()||'design';
          const fileName='SKT-Lib-'+safeName+'-'+Date.now()+'.png';
          const targetPos=self.selectedPosition||'front';
          fetch(url,{mode:'cors'}).then(function(r){if(!r.ok)throw new Error('fetch fail '+r.status);return r.blob();}).then(function(blob){
            return new Promise(function(res,rej){
              const fr=new FileReader();
              fr.onload=function(e){res(e.target.result);};
              fr.onerror=rej;
              fr.readAsDataURL(blob);
            });
          }).then(function(dataUrl){
            self.artworks[targetPos]={dataUrl:dataUrl,serverUrl:url,name:fileName,transform:{x:0,y:0,scale:1,rotation:0}};
            if(self.selectedPosition!==targetPos)self.selectPosition(targetPos);
            self.renderArtwork(targetPos);
            self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();
            self.updateStep3State();
            closePreview();
            $('#skt-flib-modal').removeClass('active');
            if(self._activeStep<=3)self.openStep(4);
            if(window.sktToast)window.sktToast('"'+pendingDesign.name+'" added — drag to position');
          }).catch(function(err){
            console.warn('[SKT] design apply failed:',err);
            self.artworks[targetPos]={dataUrl:url,serverUrl:url,name:fileName,transform:{x:0,y:0,scale:1,rotation:0}};
            if(self.selectedPosition!==targetPos)self.selectPosition(targetPos);
            self.renderArtwork(targetPos);
            self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();
            self.updateStep3State();
            closePreview();
            $('#skt-flib-modal').removeClass('active');
            if(self._activeStep<=3)self.openStep(4);
            if(window.sktToast)window.sktToast('"'+pendingDesign.name+'" added — drag to position');
          });
        };
        $('#skt-flib-modal').on('click','.skt-flib-cat-tile',function(){renderCategoryDesigns($(this).data('cat-id'));$('#skt-flib-body').scrollTop(0);});
        $('#skt-flib-modal').on('click','.skt-flib-design-tile',function(){showPreview($(this).data('design-id'));});
        $('#skt-flib-back').on('click',function(){$('#skt-flib-search').val('');renderCategories();$('#skt-flib-body').scrollTop(0);});
        $('#skt-flib-close').on('click',function(){$('#skt-flib-modal').removeClass('active');});
        $('#skt-flib-modal').on('click',function(e){if(e.target===this)$(this).removeClass('active');});
        let searchTimer=null;
        $('#skt-flib-search').on('input',function(){
          const v=$(this).val();
          clearTimeout(searchTimer);
          searchTimer=setTimeout(function(){
            if(!v||v.length<2){if(viewState.mode==='search')renderCategories();return;}
            renderSearchResults(v);
            $('#skt-flib-body').scrollTop(0);
          },200);
        });
        $('#skt-flib-pv-close').on('click',closePreview);
        $('#skt-flib-pv-cancel').on('click',closePreview);
        $('#skt-flib-pv-apply').on('click',applyDesign);
        $('#skt-flib-preview').on('click',function(e){if(e.target===this)closePreview();});
        renderCategories();
      } else {
        $('#skt-flib-search').val('');
        const evt=$._data(document.getElementById('skt-flib-back'),'events');
        $('#skt-flib-back').trigger('click');
      }
      $('#skt-flib-modal').addClass('active');
    },

    openStep:function(n){
      if(!this._stepsReady) return;
      this._activeStep = n;
      $('.skt-step').removeClass('skt-step--active');
      $('#skt-step-'+n).addClass('skt-step--active');
      if(window.innerWidth < 900){
        const el = document.getElementById('skt-step-'+n);
        if(el) setTimeout(()=>el.scrollIntoView({behavior:'smooth',block:'nearest'}),80);
      }
    },

    markStepDone:function(n){
      if(!this._stepsReady) return;
      const $step = $('#skt-step-'+n);
      $step.addClass('skt-step--done');
      $('#skt-num-'+n).html('✓');
    },

    updateStepPreview:function(n,text){
      if(!this._stepsReady) return;
      $('#skt-sp-'+n).text(text||'');
    },

    syncStepPositionTiles:function(){
      if(!this._stepsReady) return;
      const self = this;
      $('#skt-pos-grid .skt-pos-tile').each(function(){
        const pos = $(this).data('pos');
        $(this).toggleClass('skt-pos-tile--active', pos === self.selectedPosition);
        $(this).toggleClass('skt-pos-tile--has', !!self.artworks[pos]);
      });
      if(this.selectedVariant && this.variantImages){
        const imgs = this.variantImages[this.selectedVariant.id] || {};
        const fb = this.$dom.previewImage.attr('src') || '';
        ['front','back','left','right'].forEach(pos=>{
          const $img = $('#skt-pt-img-'+pos);
          if(!$img.length) return;
          const url = imgs[pos];
          if(url && url !== 'null'){ if($img.attr('src')!==url) $img.attr('src',url); }
          else if(fb){ if($img.attr('src')!==fb) $img.attr('src',fb); }
        });
      }
      const labels = {front:'Front',back:'Back',left:'L Sleeve',right:'R Sleeve'};
      this.updateStepPreview(2, labels[this.selectedPosition] || this.selectedPosition);
    },

    createStickyHeader:function(){
      $('head').append(`<style>${ARTWORK_CSS}</style>`);
      $('head').append(`<style>${FILE_MODAL_CSS}</style>`);
      $('head').append('<style>@media(max-width:768px){#mrk-sticky-header{display:none!important;}}</style>');
      $('head').append('<style>.mrk-cart-section{display:none!important;}</style>');
      $('head').append('<style>.skt-trigger-btn{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;padding:13px 16px!important;background:#ffffff!important;border:2.5px solid #111111!important;border-radius:10px!important;font-family:Oswald,sans-serif!important;font-weight:900!important;font-size:.9rem!important;text-transform:uppercase!important;letter-spacing:.07em!important;color:#8400FF!important;cursor:pointer!important;width:100%!important;box-sizing:border-box!important;margin:0!important;box-shadow:4px 4px 0 0 #111111!important;transition:box-shadow .1s ease,transform .1s ease,background .15s ease!important;outline:none!important;}.skt-trigger-btn:hover{background:#f5f0ff!important;box-shadow:2px 2px 0 0 #111111!important;transform:translate(2px,2px)!important;}.skt-trigger-btn:active{background:#ede6ff!important;box-shadow:none!important;transform:translate(4px,4px)!important;}</style>');
      $('head').append('<style>.skt-text-inp{background:#fffbeb!important;color:#111111!important;border-color:#E5E7EB!important;}.skt-text-inp::placeholder{color:#b59c4a!important;}</style>');
      $('head').append('<style>#mrk-size-guide-modal td:first-child{font-weight:700!important;color:#111111!important;text-align:left!important;}#mrk-size-guide-modal thead th,#mrk-size-guide-modal tr:first-child th,#mrk-size-guide-modal tr:first-child td{font-family:Oswald,sans-serif!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:.05em!important;}#mrk-size-guide-modal .mrk-modal__title .skt-hl{color:#FFD300!important;font-style:normal!important;}#mrk-size-guide-modal .mrk-modal__box,#mrk-size-guide-modal .mrk-modal{max-width:calc(100vw - 24px)!important;width:100%!important;margin:0 auto!important;}#mrk-size-guide-modal table{width:100%!important;}#mrk-size-guide-modal .mrk-modal__body{overflow-x:auto!important;-webkit-overflow-scrolling:touch!important;}@media(max-width:600px){#mrk-size-guide-modal .mrk-modal__title,#mrk-size-guide-modal h2,#mrk-size-guide-modal h3{font-size:.88rem!important;}#mrk-size-guide-modal td,#mrk-size-guide-modal th{padding:8px 6px!important;font-size:.75rem!important;}}</style>');
    },

    injectBgRemovalLoader:function(){
      if(document.getElementById('mrk-bg-loader')||window._sktBgRemoval||window._sktBgRemovalFail)return;
      const s=document.createElement('script');
      s.id='mrk-bg-loader';s.type='module';
      s.textContent=`import('${IMGLY_CDN}').then(function(m){window._sktBgRemoval=m.removeBackground;}).catch(function(err){window._sktBgRemovalFail=true;});`;
      document.head.appendChild(s);
    },

    showBgProgress:function(pct,label){
      let $p=$('#mrk-rmbg-progress');
      if(!$p.length){$('body').append(`<div id="mrk-rmbg-progress"><div id="mrk-rmbg-progress__box"><span id="mrk-rmbg-progress__icon">🪄</span><h3 id="mrk-rmbg-progress__title">Removing Background</h3><p id="mrk-rmbg-progress__sub">Running on your device — no upload needed.<br>First use may take 20–40 seconds while the AI model loads.</p><div id="mrk-rmbg-progress__track"><div id="mrk-rmbg-progress__fill"></div></div></div></div>`);$p=$('#mrk-rmbg-progress');}
      if(label)$('#mrk-rmbg-progress__sub').html(label);
      if(pct!=null)$('#mrk-rmbg-progress__fill').css('width',Math.min(pct,100)+'%');
    },
    hideBgProgress:function(){$('#mrk-rmbg-progress').remove();},

    showRemoveBgGuide:function(position,dataUrl,filename){
      const self=this;
      $('#mrk-rmbg-popup').remove();
      $('body').append(`<div id="mrk-rmbg-popup"><div id="mrk-rmbg-box"><div class="mrk-rmbg-hd"><h3>Remove Background — Free</h3><button class="mrk-rmbg-close" aria-label="Close">✕</button></div><div class="mrk-rmbg-body"><a class="mrk-rmbg-tool" href="https://www.pixa.com/background-remover" target="_blank" rel="noopener" style="margin-bottom:14px;"><div class="mrk-rmbg-tool__info"><span class="mrk-rmbg-tool__name">Free Background Remover</span><span class="mrk-rmbg-tool__desc">pixa.com — free, no account needed</span></div><span class="mrk-rmbg-tool__badge mrk-rmbg-tool__badge--best">Open ↗</span></a><p style="font-size:.78rem;color:#888;margin:0;line-height:1.5;">Or leave a note in the <strong>Design Notes</strong> box below, e.g.<br><em>"Please remove the background of this image."</em></p></div></div></div>`);
      const close=()=>$('#mrk-rmbg-popup').remove();
      $('#mrk-rmbg-popup').on('click',function(e){if(e.target===this)close();});
      $('#mrk-rmbg-popup .mrk-rmbg-close').on('click',close);
      $('#mrk-rmbg-reupload').on('click',function(){self._rmbgTargetPos=position;if(self.selectedPosition!==position)self.selectPosition(position);self.$dom.fileInput.trigger('click');});
      self.$dom.fileInput.one('change.rmbg',function(){if(!self._rmbgTargetPos)return;$('#mrk-rmbg-reupload').prop('disabled',true).css('opacity',.5);$('#mrk-rmbg-done').show();self.$dom.fileInput.off('change.rmbg');setTimeout(close,1600);});
    },

    loadFromLocalStorage:function(){try{const s=localStorage.getItem('mrk_uploaded_files');if(s)this.uploadedFiles=JSON.parse(s);}catch(e){}},
    saveToLocalStorage:function(){try{localStorage.setItem('mrk_uploaded_files',JSON.stringify(this.uploadedFiles));}catch(e){}},
    getDiscountTier:function(q){for(const t of DISCOUNT_TIERS){if(q>=t.min&&q<=t.max)return t.discount;}return 0;},
    isSizeUpcharge:(size)=>SIZE_UPCHARGE_THRESHOLD.includes(size),
    calculateItemPrice:function(bp,size,tq,areas){const d=this.getDiscountTier(tq);return bp*(1-d)+(areas>1?(areas-1)*getPrintSurcharge(tq):0);},

    getVariantImg:function(color){
      const isReal = function(url){ return url && url !== 'null' && !url.includes('no-image') && !url.includes('placeholder'); };
      var v=this.product&&this.product.variants&&this.product.variants.find(function(vr){return vr.option1===color||vr.option2===color||vr.option3===color;});
      if(!v||!this.variantImages)return null;
      var imgs=this.variantImages[v.id];if(!imgs)return null;
      var url=isReal(imgs['front'])?imgs['front']:isReal(imgs['back'])?imgs['back']:isReal(imgs['left'])?imgs['left']:isReal(imgs['right'])?imgs['right']:null;
      if(!url){for(var k in imgs){if(isReal(imgs[k])){url=imgs[k];break;}}}
      return url||null;
    },

    renderColorSwatches:function(){
      if(!this.product?.options)return;
      const co=this.product.options.find(o=>o.name==='Color');if(!co)return;
      const self=this;
      const SHOW=10;
      const swatchData=[];
      co.values.forEach((color,idx)=>{
        const imgUrl=self.getVariantImg(color);
        let hex=this.colorSwatches[color];
        if(!hex){const v=this.product.variants.find(v=>v.option1===color||v.option2===color||v.option3===color);if(v?.metafields?.color?.values){try{const cd=v.metafields.color.values;if(typeof cd==='string'&&cd.startsWith('#'))hex=cd;else if(cd?.hex)hex=cd.hex;}catch(e){}}}
        if(!hex){const cl=color.toLowerCase();const fp={black:'#111111',white:'#FFFFFF',navy:'#001F3F',blue:'#0074D9',red:'#FF4136',orange:'#FF851B',green:'#2ECC40',gray:'#AAAAAA',grey:'#AAAAAA',dark:'#222222',light:'#F7F7F7',heather:'#999999',gold:'#FFD700',brown:'#8B4513',purple:'#800080',pink:'#FF69B4',yellow:'#FFD700',teal:'#008080',maroon:'#800000',coral:'#FF6347',mint:'#98FF98',charcoal:'#36454F',olive:'#808000',slate:'#708090',kelly:'#4CBB17',royal:'#4169E1',cardinal:'#C41E3A',forest:'#228B22',athletic:'#AAAAAA',sport:'#AAAAAA',sand:'#C2B280',tan:'#D2B48C',cream:'#FFFDD0',ivory:'#FFFFF0',ash:'#B2BEB5',smoke:'#738276',storm:'#708090',vintage:'#A98A6E',pearl:'#EAE0C8',ice:'#D9F2F9',sky:'#87CEEB',berry:'#8B0057',plum:'#8E4585',lilac:'#C8A2C8',lavender:'#E6E6FA',rose:'#FF007F',denim:'#1560BD',indigo:'#4B0082',cobalt:'#0047AB',sapphire:'#0F52BA',turquoise:'#40E0D0',aqua:'#00FFFF',lime:'#32CD32',lemon:'#FFF44F',mustard:'#FFDB58',copper:'#B87333',bronze:'#CD7F32',silver:'#C0C0C0',arctic:'#E8F4F8',alpine:'#6B8E6E',camo:'#78866B',military:'#4B5320'};hex='#CCCCCC';for(const[k,h]of Object.entries(fp)){if(cl.includes(k)){hex=h;break;}}}
        const innerStyle=imgUrl?'background-image:url('+imgUrl+');background-size:cover;background-position:center top;':'background-color:'+hex+';';
        const isLight=!imgUrl&&['#ffffff','#fff','#F7F7F7','#f7f7f7'].includes(hex.toLowerCase());
        swatchData.push({color,hex,innerStyle,isLight,isFirst:idx===0});
      });
      const total=swatchData.length;
      const hasMore=total>SHOW;
      let html='';
      swatchData.forEach((s,idx)=>{
        const hidden=hasMore&&idx>=SHOW?' style="display:none"':'';
        const cls=`mrk-swatch skt-img-swatch${s.isFirst?' mrk-swatch--active':''}${s.isLight?' mrk-swatch--light':''}${hasMore&&idx>=SHOW?' skt-swatch-extra':''}`;
        html+=`<button type="button" class="${cls}" data-color="${s.color}" data-color-hex="${s.hex}" title="${s.color}"${hidden}><span class="mrk-swatch__inner skt-img-inner" style="${s.innerStyle}"></span></button>`;
      });
      if(hasMore){
        const remaining=total-SHOW;
        html+=`<button type="button" id="skt-swatches-toggle" style="width:38px;height:38px;border-radius:50%;border:2px solid #E5E7EB;background:#F4F4F6;font-family:'Oswald',sans-serif;font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:.04em;color:#6B7280;cursor:pointer;flex-shrink:0;transition:all .15s;line-height:1;padding:0;" title="Show more colours">+${remaining}</button>`;
      }
      this.$dom.colorSwatches.html(html);
      if(hasMore){
        let expanded=false;
        $(document).off('click','#skt-swatches-toggle').on('click','#skt-swatches-toggle',function(){
          expanded=!expanded;
          $('.skt-swatch-extra').toggle(expanded);
          $(this).text(expanded?'Less':'+'+remaining);
          $(this).css({'border-color':expanded?'#111':'#E5E7EB','color':expanded?'#111':'#6B7280'});
        });
      }
    },

    createMobileQuickBar:function(){
      const self=this;
      $('head').append(`<style id="skt-mqb-css">${MOBILE_BAR_CSS}</style>`);
      const bar=`<div id="skt-mqb"><div class="skt-mqb__sec"><div class="skt-mqb__positions"><button type="button" class="skt-mqb__pos skt-mqb__pos--on" data-pos="front"><img class="skt-mqb__pos-img" id="skt-mqb-img-front" src="" alt="Front"><span class="skt-mqb__pos-lbl">Front</span><span class="skt-mqb__pos-dot"></span></button><button type="button" class="skt-mqb__pos" data-pos="back"><img class="skt-mqb__pos-img" id="skt-mqb-img-back" src="" alt="Back"><span class="skt-mqb__pos-lbl">Back</span><span class="skt-mqb__pos-dot"></span></button><button type="button" class="skt-mqb__pos" data-pos="left"><img class="skt-mqb__pos-img" id="skt-mqb-img-left" src="" alt="L Sleeve"><span class="skt-mqb__pos-lbl">L&nbsp;Sleeve</span><span class="skt-mqb__pos-dot"></span></button><button type="button" class="skt-mqb__pos" data-pos="right"><img class="skt-mqb__pos-img" id="skt-mqb-img-right" src="" alt="R Sleeve"><span class="skt-mqb__pos-lbl">R&nbsp;Sleeve</span><span class="skt-mqb__pos-dot"></span></button></div></div><div class="skt-mqb__sec"><div class="skt-mqb__colour-row"><span class="skt-mqb__colour-name" id="skt-mqb-cname">—</span></div><div class="skt-mqb__swatches" id="skt-mqb-swatches"></div></div><div class="skt-mqb__sec"><div class="skt-mqb__btns" style="margin-bottom:8px"><button type="button" class="skt-mqb__btn skt-mqb__btn--upload" id="skt-mqb-upload"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>Upload Artwork</button><button type="button" class="skt-mqb__btn skt-mqb__btn--text" id="skt-mqb-text"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>Add Text</button></div><a href="https://www.saskatoontees.ca/pages/design-help" class="skt-mqb__help mrk-need-help-with-design" target="_blank"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>Need Design Help?</a></div></div>`;
      this.$dom.customizer.prepend(bar);
      this.$dom.customizer.find('.mrk-customizer__section').eq(0).addClass('skt-mqb-step1');
      this.$dom.customizer.find('.mrk-customizer__section').eq(1).addClass('skt-mqb-step2');
      $('#mrk-upload-btn,#mrk-selected-file,.skt-trigger-btn').addClass('skt-hide-mobile');
      this.$dom.customizer.find('.skt-mqb-step2').find('.mrk-need-help-with-design').first().addClass('skt-hide-mobile');
      const uploadBtnEl=document.getElementById('mrk-upload-btn');
      if(uploadBtnEl){let c=uploadBtnEl.parentElement;const s=['mrk-customizer','mrk-customizer-form','mrk-customizer__section'];while(c){const id=c.id||'',cl=c.className||'';if(s.some(x=>id.includes(x)||cl.includes(x)))break;if(c.querySelector('#mrk-upload-btn,.skt-trigger-btn,.mrk-need-help-with-design')){$(c).addClass('skt-hide-mobile');break;}c=c.parentElement;}}
      const $bar=$('#skt-mqb');
      $bar.on('click','.skt-mqb__pos',function(e){if($(e.target).hasClass('skt-mqb__pos-del'))return;self.selectPosition($(this).data('pos'));});
      $bar.on('click','.skt-mqb__pos-del',function(e){e.stopPropagation();e.preventDefault();const pos=$(this).closest('.skt-mqb__pos').data('pos');self.removeArtwork(pos);self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();});
      $bar.on('click','.skt-mqb__sw',function(){const color=$(this).data('color'),hex=$(this).data('hex');const $m=self.$dom.colorSwatches.find('[data-color="'+color+'"]');self.selectColor(color,hex,$m.length?$m:$(this));});
      $('#skt-mqb-upload').on('click',function(){self.openFileModal();});
      $('#skt-mqb-text').on('click',function(){const t=document.querySelector('.skt-trigger-btn');if(t){t.click();return;}if(typeof sktOpenModal==='function'&&self.product)sktOpenModal(String(self.product.id));});
      this.mobileBarReady=true;
    },

    renderMobileSwatches:function(){
      if(!this.product?.options)return;
      const co=this.product.options.find(o=>o.name==='Color');if(!co)return;
      const self=this;let html='';
      co.values.forEach(color=>{
        const imgUrl=self.getVariantImg(color);
        let hex=this.colorSwatches[color];
        if(!hex){const v=this.product.variants.find(v=>v.option1===color||v.option2===color||v.option3===color);if(v?.metafields?.color?.values){try{const cd=v.metafields.color.values;if(typeof cd==='string'&&cd.startsWith('#'))hex=cd;else if(cd?.hex)hex=cd.hex;}catch(e){}}}
        if(!hex){const cl=color.toLowerCase();const fp={black:'#111111',white:'#FFFFFF',navy:'#001F3F',blue:'#0074D9',red:'#FF4136',orange:'#FF851B',green:'#2ECC40',gray:'#AAAAAA',grey:'#AAAAAA',dark:'#222222',light:'#F7F7F7',heather:'#999999',gold:'#FFD700',brown:'#8B4513',purple:'#800080',pink:'#FF69B4',yellow:'#FFD700',teal:'#008080',maroon:'#800000',coral:'#FF6347',mint:'#98FF98',charcoal:'#36454F',olive:'#808000',slate:'#708090',kelly:'#4CBB17',royal:'#4169E1',cardinal:'#C41E3A',forest:'#228B22',athletic:'#AAAAAA',sport:'#AAAAAA',sand:'#C2B280',tan:'#D2B48C',cream:'#FFFDD0',ivory:'#FFFFF0',ash:'#B2BEB5',smoke:'#738276',storm:'#708090',pearl:'#EAE0C8',ice:'#D9F2F9',sky:'#87CEEB',berry:'#8B0057',plum:'#8E4585',lilac:'#C8A2C8',lavender:'#E6E6FA',rose:'#FF007F',denim:'#1560BD',indigo:'#4B0082',cobalt:'#0047AB',sapphire:'#0F52BA',turquoise:'#40E0D0',aqua:'#00FFFF',lime:'#32CD32',mustard:'#FFDB58',copper:'#B87333',silver:'#C0C0C0',arctic:'#E8F4F8',camo:'#78866B',military:'#4B5320'};hex='#CCCCCC';for(const[k,h]of Object.entries(fp)){if(cl.includes(k)){hex=h;break;}}}
        const isl=!imgUrl&&['#ffffff','#fff'].includes(hex.toLowerCase())?' skt-mqb__sw--light':'';
        const bgStyle=imgUrl?'background-image:url('+imgUrl+');background-size:cover;background-position:center top;background-color:'+hex:'background-color:'+hex;
        html+=`<button type="button" class="skt-mqb__sw${isl}" data-color="${color}" data-hex="${hex}" style="${bgStyle};border-radius:6px" title="${color}"></button>`;
      });
      $('#skt-mqb-swatches').html(html);
    },

    updateMobileQuickBar:function(){
      if(!this.mobileBarReady)return;const self=this;
      if(this.selectedVariant&&this.variantImages){const imgs=this.variantImages[this.selectedVariant.id]||{};const fb=this.$dom.previewImage.attr('src')||'';['front','back','left','right'].forEach(pos=>{const $img=$(`#skt-mqb-img-${pos}`);if(!$img.length)return;const url=imgs[pos];if(url&&url!=='null'){if($img.attr('src')!==url)$img.attr('src',url);$img.closest('.skt-mqb__pos').css('opacity','1');}else if(fb){if($img.attr('src')!==fb)$img.attr('src',fb);$img.closest('.skt-mqb__pos').css('opacity','0.5');}});}
      $('.skt-mqb__pos').removeClass('skt-mqb__pos--on');$(`.skt-mqb__pos[data-pos="${this.selectedPosition}"]`).addClass('skt-mqb__pos--on');
      $('.skt-mqb__pos').each(function(){const pos=$(this).data('pos'),hasArt=!!self.artworks[pos];$(this).toggleClass('skt-mqb__pos--has',hasArt);let $d=$(this).find('.skt-mqb__pos-del');if(hasArt&&!$d.length)$(this).append(`<button type="button" class="skt-mqb__pos-del" aria-label="Remove design from ${pos}" title="Remove design">×</button>`);else if(!hasArt&&$d.length)$d.remove();});
      if(this.selectedColor){$('#skt-mqb-cname').text(this.selectedColor);$('#skt-mqb .skt-mqb__sw').removeClass('skt-mqb__sw--on');const $sw=$(`#skt-mqb .skt-mqb__sw[data-color="${this.selectedColor}"]`);$sw.addClass('skt-mqb__sw--on');if($sw.length)$sw[0].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
      const art=this.artworks[this.selectedPosition];const hasRealArtwork=art&&!art.isTextDesign;
      const $up=$('#skt-mqb-upload');
      $up.toggleClass('skt-mqb__btn--upload-done',hasRealArtwork);
      $up.html(hasRealArtwork?`<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>Change Design`:`<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>Upload Artwork`);
      this.syncStepPositionTiles();
      this.updateStep3State();
    },

    setPositionArtworkLayer:function(position,toFront){$(`#mrk-artwork-${position}`).toggleClass('mrk-artwork--on-top',toFront);},
    deselectArtwork:function(){$('.mrk-artwork-item').removeClass('mrk-artwork-item--active');},

    bindEvents:function(){
      const self=this;
      this.$dom.colorSwatches.on('click','.mrk-swatch',function(e){e.preventDefault();self.selectColor($(this).data('color'),$(this).data('color-hex'),$(this));});
      this.$dom.positionButtons.on('click','.mrk-position-btn',function(e){if(!$(e.target).hasClass('mrk-position-btn__remove'))self.selectPosition($(this).data('position'));});
      this.$dom.positionButtons.on('click','.mrk-position-btn__remove',function(e){e.stopPropagation();const pos=$(this).closest('.mrk-position-btn').data('position');self.removeArtwork(pos);self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();});
      this.$dom.uploadBtn.on('click',function(e){e.preventDefault();self.openFileModal();});
      $(document).on('click','.mrk-artwork-overlay__btn',function(e){e.preventDefault();const pos=$(this).data('position');self.selectedPosition=pos;self.selectPosition(pos);self.openFileModal();});
      this.$dom.changeFileBtn.on('click',function(e){e.preventDefault();self.openFileModal();});
      this.$dom.removeFileBtn.on('click',function(e){e.preventDefault();self.removeArtwork(self.selectedPosition);self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();});
      this.$dom.fileInput.on('change',function(){if(this.files&&this.files[0]){self.handleFileUpload(this.files[0]);$(this).val('');}});
      $('.mrk-file-tab').on('click',function(){const tab=$(this).data('tab');$('.mrk-file-tab').removeClass('mrk-file-tab--active');$(this).addClass('mrk-file-tab--active');$('.mrk-file-tab-content').removeClass('mrk-file-tab-content--active');$(`.mrk-file-tab-content[data-tab="${tab}"]`).addClass('mrk-file-tab-content--active');});
      this.$dom.browseBtn.on('click',function(){self.$dom.fileInput.click();});
      const applyLib=function(e){e.preventDefault();const $i=$(e.currentTarget).closest('.mrk-file-library-item');const idx=parseInt($i.data('index'));const file=self.uploadedFiles[idx];if(!file)return;self.artworks[self.selectedPosition]={...file,transform:{x:0,y:0,scale:1,rotation:0}};self.renderArtwork(self.selectedPosition);self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();self.closeFileModal();};
      $(document).on('click','.mrk-file-library-item',applyLib);
      $(document).on('touchend','.mrk-file-library-item',applyLib);
      this.$dom.addColorBtn.on('click',function(e){e.preventDefault();self.openColorModal();});
      this.$dom.colorModal.find('.mrk-modal__close,.mrk-modal__overlay').on('click',function(){self.closeColorModal();});
      this.$dom.sizeGuideBtn.on('click',function(e){
        e.preventDefault();
        var $t=self.$dom.sizeGuideModal.find('.mrk-modal__title,h2,h3').first();
        if($t.length&&!$t.data('skt-fmt')){var txt=$t.text().trim();var m=txt.match(/^(.+?)([ ]*[|][- ][ ]*SIZE[ ]*GUIDE.*)$/i);if(m){$t.html('<span class="skt-hl">'+m[1].trim()+'</span>'+m[2]);}else if(/SIZE GUIDE/i.test(txt)){$t.html(txt.replace(/SIZE GUIDE/i,'<span style="color:#fff;font-style:normal">SIZE GUIDE</span>'));}$t.data('skt-fmt',true);}
        self.$dom.sizeGuideModal.addClass('mrk-modal--active');
      });
      this.$dom.sizeGuideModal.find('.mrk-modal__close,.mrk-modal__overlay').on('click',function(){self.$dom.sizeGuideModal.removeClass('mrk-modal--active');});
      this.$dom.modalSwatches.on('click','.mrk-swatch',function(e){e.preventDefault();self.addColorRow($(this).data('color'),$(this).data('color-hex'));self.closeColorModal();});
      this.$dom.fileModal.find('.mrk-modal__close,.mrk-modal__overlay').on('click',function(){self.closeFileModal();});
      $(document).on('click','.mrk-quantity-breaks__toggle',function(e){e.preventDefault();e.stopPropagation();const $t=$(this).closest('.mrk-quantity-breaks').find('.mrk-quantity-breaks__table'),vis=$t.css('display')!=='none';$t.css('display',vis?'none':'table');$(this).text(vis?'💰 View Price Breaks ▼':'💰 Hide Price Breaks ▲');return false;});
      this.$dom.colorRows.on('click','.mrk-color-row__remove',function(){self.removeColorRow($(this).closest('.mrk-color-row').data('row-index'));});
      this.$dom.colorRows.on('input','.mrk-quantity-input',function(){self.updateTotals();});
      this.$dom.colorRows.on('click','.skt-qty-btn[data-dir="-"]',function(){const $inp=$(this).siblings('.mrk-quantity-input');const v=Math.max(0,(parseInt($inp.val())||0)-1);$inp.val(v).trigger('input');});
      this.$dom.colorRows.on('click','.skt-qty-btn[data-dir="+"]',function(){const $inp=$(this).siblings('.mrk-quantity-input');const v=(parseInt($inp.val())||0)+1;$inp.val(v).trigger('input');});
      this.$dom.form.on('submit',function(e){e.preventDefault();self.addToCart();});
      this.bindArtworkEvents();
    },

    bindArtworkEvents:function(){
      const self=this;
      let isDragging=false,isResizing=false,isRotating=false,startX,startY,startTransform;
      $(document).on('mousedown touchstart','.mrk-artwork-item',function(e){
        if($(e.target).hasClass('mrk-artwork-item__remove')||$(e.target).hasClass('mrk-artwork-item__bar-btn'))return;
        e.preventDefault();const pos=$(this).data('position');self.activeArtwork=pos;
        $('.mrk-artwork-item').removeClass('mrk-artwork-item--active');$(this).addClass('mrk-artwork-item--active');
        const touch=e.type==='touchstart'?e.originalEvent.touches[0]:e;
        startX=touch.clientX;startY=touch.clientY;startTransform={...self.artworks[pos].transform};
        if($(e.target).hasClass('mrk-artwork-item__resize')){isResizing=true;self.preventScroll();}
        else if($(e.target).hasClass('mrk-artwork-item__rotate')){isRotating=true;self.preventScroll();}
        else{isDragging=true;self.preventScroll();}
      });
      $(document).on('mousemove touchmove',function(e){
        if(!self.activeArtwork)return;if(e.type==='touchmove')e.preventDefault();
        const touch=e.type==='touchmove'?e.originalEvent.touches[0]:e;
        const dx=touch.clientX-startX,dy=touch.clientY-startY;
        const art=self.artworks[self.activeArtwork];
        if(isDragging){art.transform.x=startTransform.x+dx;art.transform.y=startTransform.y+dy;}
        else if(isResizing){art.transform.scale=Math.max(.1,Math.min(3,startTransform.scale+dy/100));}
        else if(isRotating){art.transform.rotation=(startTransform.rotation+dx/2)%360;}
        self.updateArtworkPosition(self.activeArtwork);
      });
      $(document).on('mouseup touchend',function(){isDragging=false;isResizing=false;isRotating=false;self.activeArtwork=null;self.allowScroll();});
      $(document).on('click',function(e){const $t=$(e.target);if(!$t.closest('.mrk-artwork-item,.mrk-artwork-item__bar,#skt-mqb,#mrk-position-buttons,.mrk-modal,#mrk-rmbg-popup,#mrk-rmbg-progress').length)self.deselectArtwork();});
      $(document).on('click','.mrk-artwork-item__remove',function(e){e.stopPropagation();const pos=$(this).closest('.mrk-artwork-item').data('position');self.removeArtwork(pos);self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();});
      $(document).on('click','.mrk-artwork-item__raise',function(e){e.stopPropagation();self.setPositionArtworkLayer($(this).closest('.mrk-artwork-item').data('position'),true);});
      $(document).on('click','.mrk-artwork-item__lower',function(e){e.stopPropagation();self.setPositionArtworkLayer($(this).closest('.mrk-artwork-item').data('position'),false);});
      $(document).on('click','.mrk-artwork-item__rmbg',async function(e){
        e.stopPropagation();
        const pos=$(this).closest('.mrk-artwork-item').data('position');
        const art=self.artworks[pos];
        if(!art||art.isTextDesign)return;
        if(window._sktBgRemovalFail){self.showRemoveBgGuide(pos,art.dataUrl,art.name);return;}
        self.showBgProgress(5,'Loading AI model — this takes 20–40 seconds on first use…');
        let waited=0;
        while(!window._sktBgRemoval&&!window._sktBgRemovalFail&&waited<90000){await new Promise(r=>setTimeout(r,500));waited+=500;self.showBgProgress(Math.min(5+waited/900,40));}
        if(!window._sktBgRemoval){self.hideBgProgress();self.showRemoveBgGuide(pos,art.dataUrl,art.name);return;}
        try{
          self.showBgProgress(42,'AI is removing the background…');
          const resp=await fetch(art.dataUrl);const blob=await resp.blob();
          const resultBlob=await window._sktBgRemoval(blob,{publicPath:IMGLY_CDN.replace('browser.js',''),output:{format:'image/png',quality:0.9},progress:function(key,current,total){if(total>0){const pct=42+Math.round((current/total)*55);self.showBgProgress(pct,'AI is removing the background… '+Math.round(current/total*100)+'%');}}});
          const newDataUrl=await new Promise((res,rej)=>{const r=new FileReader();r.onload=ev=>res(ev.target.result);r.onerror=rej;r.readAsDataURL(resultBlob);});
          art.dataUrl=newDataUrl;
          $(`.mrk-artwork-item[data-position="${pos}"] .mrk-artwork-item__image`).attr('src',newDataUrl);
          self.hideBgProgress();
          if(window.sktToast)window.sktToast('Background removed! Re-position your artwork as needed.');
        }catch(err){console.error('[MRK] BG removal processing error:',err);self.hideBgProgress();self.showRemoveBgGuide(pos,art.dataUrl,art.name);}
      });
    },

    preventScroll:function(){$('body').css({overflow:'hidden',position:'fixed',width:'100%'});},
    allowScroll:function(){$('body').css({overflow:'',position:'',width:''});},

    initializeState:function(){const $first=this.$dom.colorSwatches.find('.mrk-swatch').first();if($first.length)this.selectColor($first.data('color'),$first.data('color-hex'),$first);this.selectedPosition='front';this.selectPosition('front');if(this.selectedColor)this.addColorRow(this.selectedColor,this.selectedColorHex);this.updatePositionButtons();this.updateTotals();this.renderMobileSwatches();this.updateMobileQuickBar();this.positionTextTrigger();
      this.openStep(1);
      this.applyDesignFromUrl();
    },

    applyDesignFromUrl:function(){
      var self=this;
      try{
        var params=new URLSearchParams(window.location.search);
        var designHandle=params.get('design');
        if(!designHandle)return;
        var data={designs:[]};
        var dataEl=document.getElementById('skt-free-designs-data');
        if(!dataEl)return;
        try{data=JSON.parse(dataEl.textContent);}catch(e){console.warn('[MRK] free designs data parse failed:',e);return;}
        var design=(data.designs||[]).find(function(d){return d.handle===designHandle;});
        if(!design||!design.image_url){console.warn('[MRK] design not found for handle:',designHandle);return;}
        var url=design.image_url;
        var safeName=(design.name||'design').replace(/[^a-z0-9_\- ]/gi,'').trim()||'design';
        var fileName='SKT-Lib-'+safeName+'-'+Date.now()+'.png';
        var targetPos=self.selectedPosition||'front';
        fetch(url,{mode:'cors'}).then(function(r){if(!r.ok)throw new Error('fetch fail '+r.status);return r.blob();}).then(function(blob){
          return new Promise(function(res,rej){
            var fr=new FileReader();
            fr.onload=function(e){res(e.target.result);};
            fr.onerror=rej;
            fr.readAsDataURL(blob);
          });
        }).then(function(dataUrl){
          self.artworks[targetPos]={dataUrl:dataUrl,serverUrl:url,name:fileName,transform:{x:0,y:0,scale:1,rotation:0}};
          if(self.selectedPosition!==targetPos)self.selectPosition(targetPos);
          self.renderArtwork(targetPos);
          self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();
          self.updateStep3State();
          if(self._activeStep<=2)self.openStep(3);
          if(window.sktToast)window.sktToast('"'+design.name+'" applied — pick your color, size, and quantity to checkout');
          try{
            var newUrl=window.location.pathname+window.location.hash;
            window.history.replaceState({},'',newUrl);
          }catch(e){}
        }).catch(function(err){
          console.warn('[MRK] design preload failed:',err);
          self.artworks[targetPos]={dataUrl:url,serverUrl:url,name:fileName,transform:{x:0,y:0,scale:1,rotation:0}};
          if(self.selectedPosition!==targetPos)self.selectPosition(targetPos);
          self.renderArtwork(targetPos);
          self.updateFileDisplay();self.updatePositionButtons();self.updateTotals();
          self.updateStep3State();
          if(self._activeStep<=2)self.openStep(3);
        });
      }catch(err){console.warn('[MRK] applyDesignFromUrl error:',err);}
    },

    positionTextTrigger:function(){
      if(!this.product)return;
      if(this._stepsReady) return;
      var pid=String(this.product.id);
      var $overlay=$('#skt-text-overlay-'+pid);
      if(!$overlay.length)return;
      if(window.innerWidth>=600){
        var $uploadBtn=this.$dom.uploadBtn;
        var $helpBtn=$uploadBtn.closest('.mrk-customizer__section,.mrk-customizer').find('.mrk-need-help-with-design').first();
        if($helpBtn.length&&!$.contains($helpBtn.parent()[0],$overlay[0])){$overlay.insertBefore($helpBtn);}
        else if($uploadBtn.length&&!$.contains($uploadBtn.parent()[0],$overlay[0])){$overlay.insertAfter($uploadBtn);}
        $overlay.find('.skt-trigger-btn').css({'width':'100%','box-sizing':'border-box','margin':'0','border-radius':'0','border':'none','padding':'14px 16px','font-size':'.9rem','justify-content':'center'});
      }
    },

    selectColor:function(color,colorHex,$swatch){
      this.selectedColor=color;this.selectedColorHex=colorHex;
      this.$dom.colorSwatches.find('.mrk-swatch').removeClass('mrk-swatch--active');
      $swatch.addClass('mrk-swatch--active');
      this.$dom.selectedColorName.text(color);
      this.updateVariant();this.updatePreviewImage();this.updateSwatchesImages();
      if(this.colorRows.length>0&&this.colorRows[0].color!==color){this.colorRows.shift();this.addColorRowAtIndex(color,colorHex,0);}
      this.updateMobileQuickBar();
      $('#skt-step1-colorname').text(color);
      this.updateStepPreview(1, color);
      this.markStepDone(1);
      this.syncStepPositionTiles();
      this.updateOrderSidebar();
    },

    selectPosition:function(position){
      this.deselectArtwork();
      this.selectedPosition=position;
      this.updateVariant();
      this.$dom.uploadPosition.text(position.toUpperCase());
      this.updatePositionButtons();
      $('.mrk-artwork-overlay').hide();
      $(`#mrk-artwork-${position}`).show();
      this.updatePreviewImage();
      this.updateFileDisplay();
      this.updateMobileQuickBar();
      this.updateStep3Cards();
      this.markStepDone(2);
      this.updateOrderSidebar();
    },

    updatePositionButtons:function(){const self=this;this.$dom.positionButtons.find('.mrk-position-btn').each(function(){const pos=$(this).data('position'),$rm=$(this).find('.mrk-position-btn__remove');const has=self.artworks[pos]!==undefined,isSel=self.selectedPosition===pos;$(this).removeClass('mrk-position-btn--selected mrk-position-btn--active');if(isSel)$(this).addClass('mrk-position-btn--selected');if(has){$(this).addClass('mrk-position-btn--active');$rm.show();}else{$rm.hide();}});},
    updateVariant:function(){if(!this.product||!this.selectedColor)return;const v=this.product.variants.find(v=>v.option1===this.selectedColor||v.option2===this.selectedColor||v.option3===this.selectedColor);if(v)this.selectedVariant=v;},
    updatePreviewImage:function(){if(!this.selectedVariant||!this.variantImages)return;const imgs=this.variantImages[this.selectedVariant.id];if(imgs&&imgs[this.selectedPosition]&&imgs[this.selectedPosition]!=='null'){this.$dom.previewImage.attr('src',imgs[this.selectedPosition]);const pc=this.config.positions[this.selectedPosition];if(pc)$(`#mrk-artwork-${this.selectedPosition}`).css(pc);}},
    updatePreviewImageForPosition:function(position){return new Promise(resolve=>{if(!this.selectedVariant||!this.variantImages){resolve();return;}const imgs=this.variantImages[this.selectedVariant.id];if(!imgs||!imgs[position]||imgs[position]==='null'){resolve();return;}const url=imgs[position],$img=this.$dom.previewImage;const pc=this.config.positions[position];if(pc)$(`#mrk-artwork-${position}`).css(pc);if($img.attr('src')===url){resolve();return;}$img.one('load',resolve);$img.one('error',resolve);$img.attr('src',url);});},
    updateSwatchesImages:function(){if(!this.selectedVariant||!this.variantImages)return;const imgs=this.variantImages[this.selectedVariant.id];$('.mrk-position-btn').each(function(){if(imgs){const u=imgs[$(this).data('position')];if(u&&u!=='null')$(this).find('img').attr('src',u);}});},
    updateFileDisplay:function(){const art=this.artworks[this.selectedPosition];if(art&&!art.isTextDesign){this.$dom.selectedFile.show();this.$dom.selectedFile.find('.mrk-selected-file__position').text(this.selectedPosition.toUpperCase());this.$dom.selectedFile.find('.mrk-selected-file__name').text(art.name);this.$dom.uploadBtn.hide();}else{this.$dom.selectedFile.hide();this.$dom.uploadBtn.show();}},

    openFileModal:function(){this.renderFileLibrary();this.$dom.fileModal.addClass('mrk-modal--active');},
    closeFileModal:function(){this.$dom.fileModal.removeClass('mrk-modal--active');},
    renderFileLibrary:function(){
      const self=this;
      const uploadTile=`<div id="mrk-upload-tile" style="touch-action:manipulation;cursor:pointer;border:2.5px dashed #8400FF;border-radius:12px;background:#faf5ff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:20px 12px;text-align:center;transition:background .15s;"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#8400FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><span style="font-family:'Oswald',sans-serif;font-weight:700;font-size:.78rem;text-transform:uppercase;letter-spacing:.06em;color:#8400FF;">Upload Your Design</span></div>`;
      const recentHtml=this.uploadedFiles.length?`<p style="font-family:'Oswald',sans-serif;font-size:.68rem;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#aaa;margin:14px 0 8px;grid-column:1/-1;">Recent Uploads</p>`+this.uploadedFiles.map((f,i)=>`<div class="mrk-file-library-item" data-index="${i}" style="touch-action:manipulation;cursor:pointer;"><div class="mrk-file-library-item__preview"><img src="${f.dataUrl}" alt="${f.name}"></div><div class="mrk-file-library-item__name">${f.name}</div></div>`).join(''):'';
      this.$dom.fileLibrary.html(uploadTile + recentHtml);
      $('#mrk-upload-tile').on('click',function(){self.$dom.fileInput.trigger('click');});
    },

    async uploadImageToServer(file){
      const isImage=(file.type||'').indexOf('image/')===0;
      if(isImage){
        const imgUrl=URL.createObjectURL(file);
        const ok=await new Promise(res=>{
          const img=new Image();
          img.onload=()=>{const mp=(img.width*img.height)/1e6;URL.revokeObjectURL(imgUrl);if(mp>25){alert(`File too large: ${mp.toFixed(2)}MP`);res(false);}else{res(true);}};
          img.onerror=()=>{URL.revokeObjectURL(imgUrl);res(true);};
          img.src=imgUrl;
        });
        if(!ok)return null;
      }
      const ts=new Date().toISOString().slice(0,19).replace(/[:T]/g,'-');
      const clean=(file.name||'artwork').replace(/[^a-z0-9._\- ]/gi,'').replace(/ +/g,'-');
      const safe='SKT-Artwork-'+ts+'-'+clean;
      let b64;
      try{
        b64=await new Promise((res,rej)=>{const r=new FileReader();r.onload=e=>res(e.target.result.split(',')[1]);r.onerror=rej;r.readAsDataURL(file);});
      }catch(e){console.error('[MRK] artwork read failed',e);return 'UPLOAD FAILED - '+safe;}
      const post=async(url)=>{
        const p=new URLSearchParams();
        p.append('data',b64);
        p.append('fileName',safe);
        p.append('filename',safe);
        p.append('mimeType',file.type||'application/octet-stream');
        const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:p.toString()});
        const j=await r.json();
        return (j&&(j.fileUrl||j.url||j.webViewLink))||null;
      };
      try{
        const u=await post('https://script.google.com/macros/s/AKfycbxhjWmat2DwB-WCVT56_PXOVw62b5ENVtMzrp0FLUy08sNevk1OffU8cJNL6qSBaMgx/exec');
        if(u){console.log('[MRK] artwork uploaded:',u);return u;}
      }catch(e){console.warn('[MRK] apps script upload failed:',e);}
      try{
        const u2=await post(WORKER_URL);
        if(u2){console.log('[MRK] artwork uploaded (worker fallback):',u2);return u2;}
      }catch(e){console.warn('[MRK] worker upload failed:',e);}
      console.error('[MRK] ALL artwork uploads failed');
      return 'UPLOAD FAILED - '+safe;
    },

    async handleFileUpload(file){
      if(file.size>50*1024*1024){alert('Max 50 MB');return;}
      let dataUrl;
      try{dataUrl=await new Promise((res,rej)=>{const r=new FileReader();r.onload=e=>res(e.target.result);r.onerror=()=>rej(new Error('read fail'));r.readAsDataURL(file);});}
      catch(err){alert('Could not read file. Please try again.');return;}
      const targetPos=this._rmbgTargetPos||this.selectedPosition;
      this._rmbgTargetPos=null;
      const fd={dataUrl,serverUrl:null,name:file.name};
      this.artworks[targetPos]={...fd,transform:{x:0,y:0,scale:1,rotation:0}};
      if(this.selectedPosition!==targetPos)this.selectPosition(targetPos);
      this.renderArtwork(targetPos);
      this.updateFileDisplay();this.updatePositionButtons();this.updateTotals();
      this.closeFileModal();
      this.updateStep3State();
      if(this._activeStep<=3)this.openStep(4);
      const libIdx=this.uploadedFiles.length;
      this.uploadedFiles.push(fd);this.saveToLocalStorage();
      this.uploadImageToServer(file).then(serverUrl=>{
        if(!serverUrl)return;
        if(this.uploadedFiles[libIdx])this.uploadedFiles[libIdx].serverUrl=serverUrl;
        if(this.artworks[targetPos]&&this.artworks[targetPos].dataUrl===dataUrl)this.artworks[targetPos].serverUrl=serverUrl;
        this.saveToLocalStorage();
      }).catch(err=>console.warn('[MRK] Background upload failed:',err));
    },
renderArtwork:function(position){
      const art=this.artworks[position];
      $(`#mrk-artwork-${position} .mrk-artwork-overlay__outline`).hide();
      $(`#mrk-artwork-${position} .mrk-artwork-overlay__canvas`).html(`<div class="mrk-artwork-item" data-position="${position}"><img src="${art.dataUrl}" alt="${art.name}" class="mrk-artwork-item__image"><button type="button" class="mrk-artwork-item__control mrk-artwork-item__remove" aria-label="Remove artwork">×</button><button type="button" class="mrk-artwork-item__control mrk-artwork-item__resize" aria-label="Resize artwork">⇲</button><button type="button" class="mrk-artwork-item__control mrk-artwork-item__rotate" aria-label="Rotate artwork">↻</button><div class="mrk-artwork-item__bar"><button type="button" class="mrk-artwork-item__bar-btn mrk-artwork-item__raise" title="Raise artwork above text"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="17 11 12 6 7 11"/><line x1="12" y1="6" x2="12" y2="18"/></svg>Raise</button><span class="mrk-artwork-item__bar-sep"></span><button type="button" class="mrk-artwork-item__bar-btn mrk-artwork-item__lower" title="Lower artwork below text"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="17 13 12 18 7 13"/><line x1="12" y1="6" x2="12" y2="18"/></svg>Lower</button><span class="mrk-artwork-item__bar-sep"></span><button type="button" class="mrk-artwork-item__bar-btn mrk-artwork-item__rmbg" title="Remove background (AI, free)"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="3" x2="9" y2="21" stroke-dasharray="2 2"/><line x1="15" y1="3" x2="15" y2="21" stroke-dasharray="2 2"/><line x1="3" y1="9" x2="21" y2="9" stroke-dasharray="2 2"/><line x1="3" y1="15" x2="21" y2="15" stroke-dasharray="2 2"/></svg>Remove BG</button></div></div>`);
      this.updateArtworkPosition(position);
      this.updateMobileQuickBar();
      this.injectBgRemovalLoader();
      this.syncStepPositionTiles();
      this.updateStep3Cards();
      setTimeout(()=>{$(`.mrk-artwork-item[data-position="${position}"]`).addClass('mrk-artwork-item--active');},50);
    },

    updateArtworkPosition:function(position){
      const art=this.artworks[position];
      $(`.mrk-artwork-item[data-position="${position}"]`).css('transform',`translate(calc(-50% + ${art.transform.x}px), calc(-50% + ${art.transform.y}px)) scale(${art.transform.scale}) rotate(${art.transform.rotation}deg)`);
    },

    removeArtwork:function(position){
      delete this.artworks[position];
      $(`#mrk-artwork-${position} .mrk-artwork-overlay__canvas`).empty();
      $(`#mrk-artwork-${position} .mrk-artwork-overlay__outline`).show();
      this.setPositionArtworkLayer(position,false);
      this.updateMobileQuickBar();
      this.syncStepPositionTiles();
      this.updateStep3Cards();
      this.updateStep3State();
      this.updateOrderSidebar();
    },

    openColorModal:function(){let html='';this.$dom.colorSwatches.find('.mrk-swatch').each(function(){html+=`<button type="button" class="mrk-swatch" data-color="${$(this).data('color')}" data-color-hex="${$(this).data('color-hex')}"><span class="mrk-swatch__inner" style="background-color:${$(this).data('color-hex')};"></span></button>`;});this.$dom.modalSwatches.html(html);this.$dom.colorModal.addClass('mrk-modal--active');},
    closeColorModal:function(){this.$dom.colorModal.removeClass('mrk-modal--active');},

    addColorRow:function(color,colorHex){if(this.colorRows.find(r=>r.color===color)){alert(`${color} already added`);return;}const row={color,colorHex,sizes:{}};this.getAvailableSizes().forEach(size=>{const v=this.findVariant(color,size);row.sizes[size]={quantity:0,price:v?v.price/100:0,available:v?v.available:false};});this.colorRows.push(row);this.renderColorRows();},
    addColorRowAtIndex:function(color,colorHex,index){const row={color,colorHex,sizes:{}};this.getAvailableSizes().forEach(size=>{const v=this.findVariant(color,size);row.sizes[size]={quantity:0,price:v?v.price/100:0,available:v?v.available:false};});this.colorRows.splice(index,0,row);this.renderColorRows();},
    removeColorRow:function(index){this.colorRows.splice(index,1);this.renderColorRows();this.updateTotals();},
    getAvailableSizes:function(){if(!this.product?.options)return[];const s=this.product.options.find(o=>o.name==='Size');return s?s.values:[];},

    renderColorRows:function(){
      const sizes=this.getAvailableSizes(),showRem=this.colorRows.length>1;
      let total=0;
      this.colorRows.forEach(r=>Object.keys(r.sizes).forEach(s=>{total+=r.sizes[s].quantity||0;}));
      const disc=this.getDiscountTier(total),areas=Object.keys(this.artworks).length;
      let html='';
      this.colorRows.forEach((row,idx)=>{
        html+=`<div class="mrk-color-row" data-row-index="${idx}"><div class="mrk-color-row__header"><div class="mrk-color-row__info"><span class="mrk-color-row__swatch" style="background-color:${row.colorHex};"></span><span class="mrk-color-row__name">${row.color}</span></div>${showRem?`<button type="button" class="mrk-color-row__remove">&times;</button>`:''}</div><div class="mrk-size-grid">${sizes.map(size=>{const sd=row.sizes[size],av=sd&&sd.available;const bp=sd?sd.price:0;const ps=areas>1?(areas-1)*getPrintSurcharge(total):0;const orig=bp+ps,disc2=bp*(1-disc)+ps;let ph=`<span class="mrk-size-input__price">$${disc2.toFixed(2)}</span>`;if(disc>0)ph+=`<span class="mrk-size-input__original-price" style="text-decoration:line-through;color:#ccc;font-size:12px;display:block;">$${orig.toFixed(2)}</span>`;return`<div class="mrk-size-input ${!av?'mrk-size-input--unavailable':''}"><label class="mrk-size-input__label">${size}</label><div class="skt-qty-wrap"><button type="button" class="skt-qty-btn" data-dir="-" data-row-index="${idx}" data-size="${size}" ${!av?'disabled':''}>−</button><input type="number" class="mrk-quantity-input" min="0" value="${sd?sd.quantity:0}" data-row-index="${idx}" data-size="${size}" ${!av?'disabled':''}><button type="button" class="skt-qty-btn" data-dir="+" data-row-index="${idx}" data-size="${size}" ${!av?'disabled':''}>+</button></div>${ph}${!av?'<span class="mrk-size-input__status">Out of stock</span>':''}</div>`;}).join('')}</div></div>`;
      });
      this.$dom.colorRows.html(html);
      this.updateTotals();
    },

    updateTotals:function(){
      let total=0,sub=0,origSub=0;
      const areas=Object.keys(this.artworks).length;
      this.$dom.colorRows.find('.mrk-quantity-input').each(function(){const ri=$(this).data('row-index'),sz=$(this).data('size'),q=parseInt($(this).val())||0;if(MRK.colorRows[ri]&&MRK.colorRows[ri].sizes[sz]){MRK.colorRows[ri].sizes[sz].quantity=q;total+=q;}});
      const disc=this.getDiscountTier(total),ps=getPrintSurcharge(total);
      this.$dom.colorRows.find('.mrk-size-input').each(function(){const $i=$(this).find('.mrk-quantity-input'),ri=$i.data('row-index'),sz=$i.data('size');if(MRK.colorRows[ri]&&MRK.colorRows[ri].sizes[sz]){const bp=MRK.colorRows[ri].sizes[sz].price;const pr=areas>1?(areas-1)*ps:0;const dp=bp*(1-disc)+pr,op=bp+pr;const $sp=$(this).find('.mrk-size-input__price');$sp.text(`$${dp.toFixed(2)}`);let $op=$(this).find('.mrk-size-input__original-price');if(disc>0){if(!$op.length)$sp.after(`<span class="mrk-size-input__original-price" style="text-decoration:line-through;color:#ccc;font-size:12px;display:block;">$${op.toFixed(2)}</span>`);else $op.text(`$${op.toFixed(2)}`);}else{if($op.length)$op.remove();}}});
      if(total>0){this.$dom.colorRows.find('.mrk-quantity-input').each(function(){const ri=$(this).data('row-index'),sz=$(this).data('size'),q=parseInt($(this).val())||0;if(q>0&&MRK.colorRows[ri]){const bp=MRK.colorRows[ri].sizes[sz].price,pc=areas>1?(areas-1)*ps:0;origSub+=q*(bp+pc);sub+=q*(bp*(1-disc)+pc);}});}
      this.$dom.totalItems.text(total);
      if(total>0){const save=origSub-sub,ppi=total>0?(sub/total).toFixed(2):'0.00';const saveBadge=disc>0?`<span style="background:#FFD300;color:#111111;padding:3px 10px;border-radius:4px;font-family:'Oswald',sans-serif;font-weight:900;font-size:11px;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap;">SAVE $${save.toFixed(2)}</span>`:'';const origPrice=disc>0?`<span style="font-family:'Oswald',sans-serif;font-size:13px;color:#aaa;text-decoration:line-through;margin-right:6px;">$${origSub.toFixed(2)}</span>`:'';this.$dom.subtotal.html(`<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 16px;background:#111111;border-radius:10px;margin:4px 0 0;flex-wrap:wrap;"><div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;">${origPrice}<span style="font-family:'Oswald',sans-serif;font-weight:900;font-size:1.5rem;color:#FFD300;line-height:1;">$${sub.toFixed(2)} <span style="font-size:.75rem;font-weight:600;color:rgba(255,211,0,.6);">CAD</span></span>${saveBadge}</div><div style="text-align:right;"><div style="font-family:'Oswald',sans-serif;font-size:12px;font-weight:700;color:rgba(255,255,255,.55);text-transform:uppercase;letter-spacing:.06em;">$${ppi}/item &middot; ${total} item${total!==1?'s':''}</div></div></div><style>@media(max-width:480px){#mrk-subtotal>div{flex-direction:column!important;align-items:flex-start!important;gap:6px!important;}}</style>`);}
      else{this.$dom.subtotal.html('');}
      if(total===0)this.$dom.submitBtn.prop('disabled',true).text('Please enter quantities for at least one colour and size');
      else if(areas===0)this.$dom.submitBtn.prop('disabled',true).text('Please upload artwork for at least one print area');
      else this.$dom.submitBtn.prop('disabled',false).text('Add to Cart');
      if(total>0){this.updateStepPreview(4,total+' item'+(total!==1?'s':''));this.markStepDone(4);}else{this.updateStepPreview(4,'');}
      $('#skt-price-breaks .skt-tier').each(function(){const mn=parseInt($(this).data('min')),mx=parseInt($(this).data('max'));$(this).toggleClass('skt-tier--active',total>=mn&&total<=mx);});
      this.updateStickyBar();
      this.updateOrderSidebar();
    },

    findVariant:function(color,size){if(!this.product?.variants)return null;return this.product.variants.find(v=>{const mc=v.option1===color||v.option2===color||v.option3===color;const ms=v.option1===size||v.option2===size||v.option3===size;return mc&&ms;});},

    async addToCart(){
      if(this._processing)return;
      let hasQ=false;
      this.colorRows.forEach(r=>Object.keys(r.sizes).forEach(s=>{if(r.sizes[s].quantity>0)hasQ=true;}));
      if(!hasQ){alert('Please add quantities');return;}
      if(!Object.keys(this.artworks).length){alert('Please upload artwork or add text for at least one print area');return;}
      this._processing=true;
      this.$dom.submitBtn.prop('disabled',true).text('Processing…').css({'opacity':'0.55','cursor':'not-allowed','pointer-events':'none'});
      $('#skt-sticky-bar__btn').prop('disabled',true).text('Processing…');
      $('#skt-os-btn').prop('disabled',true).text('Processing…');
      this.showLoadingPopup();this.setLoadingStep(2);
      try{
        let total=0;
        this.colorRows.forEach(r=>Object.keys(r.sizes).forEach(s=>{total+=parseInt(r.sizes[s].quantity)||0;}));
        const disc=this.getDiscountTier(total),areas=Object.keys(this.artworks).length,items=[];
        this.colorRows.forEach(row=>{Object.keys(row.sizes).forEach(size=>{const qty=row.sizes[size].quantity;if(qty>0){const pac=Object.keys(this.artworks).length||1;const paLabel=pac===1?'1 Print Area':pac+' Print Areas';const hasPA=this.product.options&&this.product.options.some(o=>o.name==='# of Print Areas');const v=hasPA?this.product.variants.find(x=>{const mc=x.option1===row.color||x.option2===row.color||x.option3===row.color;const ms=x.option1===size||x.option2===size||x.option3===size;const mp=x.option1===paLabel||x.option2===paLabel||x.option3===paLabel;return mc&&ms&&mp;}):this.findVariant(row.color,size);if(v){const ip=hasPA?(v.price/100*(1-disc)):this.calculateItemPrice(this.basePrice,size,total,areas);const item={id:v.id,quantity:qty,properties:{'Color':row.color,'Size':size,'Base Price':'$'+this.basePrice.toFixed(2),'Discount':(disc*100).toFixed(0)+'%','Final Price per Item':'$'+ip.toFixed(2)}};Object.keys(this.artworks).forEach(pos=>{const art=this.artworks[pos];item.properties[`Artwork ${pos}`]=art.isTextDesign?'Text Design':art.serverUrl||art.name;});const notes=this.$dom.designerNotes.val();if(notes)item.properties['Designer Notes']=notes;items.push(item);}}});});
        if(!items.length){alert('Error creating cart items');this._processing=false;this.hideLoadingPopup();this.$dom.submitBtn.prop('disabled',false).text('Add to Cart').css({'opacity':'','cursor':'','pointer-events':''});return;}
        this.setLoadingStep(3);
        await new Promise((resolve,reject)=>{$.ajax({type:'POST',url:'/cart/add.js',data:JSON.stringify({items}),contentType:'application/json',dataType:'json',success:resolve,error:(xhr,s,err)=>reject(new Error(err||'Cart add failed'))});});
        this.setLoadingStep(4);this.completeLoadingPopup();
        const dc=this.getDiscountCodeForQty(total);
        setTimeout(()=>{window.location.href=dc?`/discount/${dc}?redirect=/cart`:'/cart';},1800);
      }catch(err){console.error('addToCart error',err);alert('Error adding to cart. Please try again.');this._processing=false;this.hideLoadingPopup();this.$dom.submitBtn.prop('disabled',false).text('Add to Cart').css({'opacity':'','cursor':'','pointer-events':''});}
    },

    getDiscountCodeForQty:function(q){if(q>=100)return'BULK100';if(q>=72)return'BULK72';if(q>=48)return'BULK48';if(q>=24)return'BULK24';if(q>=12)return'BULK12';return null;},

    injectPopups:function(){$('head').append(`<style>#mrk-loading-popup{display:none;position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:999999;align-items:center;justify-content:center;backdrop-filter:blur(4px);}#mrk-loading-popup.active{display:flex;}#mrk-loading-popup__box{background:#111;border:2px solid #8400FF;border-radius:20px;box-shadow:0 0 60px rgba(132,0,255,.5),6px 6px 0 0 #FFD300;padding:44px 48px 40px;max-width:400px;width:90%;text-align:center;}#mrk-loading-popup__icon{font-size:52px;margin-bottom:18px;display:block;animation:mrk-bob .8s ease-in-out infinite alternate;}@keyframes mrk-bob{from{transform:translateY(0);}to{transform:translateY(-6px);}}#mrk-loading-popup__title{font-family:'Oswald',sans-serif;font-weight:900;font-size:1.5rem;text-transform:uppercase;letter-spacing:.08em;color:#fff;margin:0 0 10px;}#mrk-loading-popup__msg{font-size:.88rem;color:rgba(255,255,255,.5);margin:0 0 28px;line-height:1.6;min-height:2.6em;transition:opacity .3s;}.mrk-loading-bar-track{height:6px;background:rgba(255,255,255,.08);border-radius:3px;overflow:hidden;margin-bottom:10px;position:relative;}.mrk-loading-bar-fill{height:100%;background:#8400FF;border-radius:3px;width:0%;transition:width 1s cubic-bezier(.4,0,.2,1);}#mrk-loading-popup__pct{font-family:'Oswald',sans-serif;font-size:.7rem;color:rgba(255,255,255,.3);letter-spacing:.08em;text-transform:uppercase;margin:0 0 14px;}.mrk-loading-pulse{position:absolute;top:0;left:-40%;width:40%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.35),transparent);animation:mrk-sweep 1.8s ease-in-out infinite;border-radius:3px;}@keyframes mrk-sweep{0%{left:-40%;}100%{left:110%;}}#mrk-loading-popup__slow{font-size:.72rem;color:rgba(255,255,255,.25);margin:8px 0 0;line-height:1.5;display:none;}#mrk-designhelp-popup{display:none;position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:999999;align-items:center;justify-content:center;}#mrk-designhelp-popup.active{display:flex;}#mrk-designhelp-popup__box{background:#fff;border:2px solid #111;border-radius:16px;box-shadow:8px 8px 0 0 #FFD300;padding:36px 40px;max-width:400px;width:90%;text-align:center;}#mrk-designhelp-popup__icon{font-size:40px;margin-bottom:12px;display:block;}#mrk-designhelp-popup__title{font-family:'Oswald',sans-serif;font-weight:900;font-size:1.25rem;text-transform:uppercase;letter-spacing:.06em;color:#111;margin:0 0 10px;}#mrk-designhelp-popup__body{font-size:.875rem;color:#555;line-height:1.6;margin:0 0 24px;}.mrk-designhelp-popup__actions{display:flex;gap:12px;justify-content:center;}.mrk-designhelp-popup__btn-stay{flex:1;padding:12px 16px;background:#111;color:#fff;border:none;border-radius:8px;font-family:'Oswald',sans-serif;font-weight:700;font-size:.875rem;text-transform:uppercase;cursor:pointer;}.mrk-designhelp-popup__btn-stay:hover{background:#333;}.mrk-designhelp-popup__btn-leave{flex:1;padding:12px 16px;background:#fff;color:#111;border:2px solid #ddd;border-radius:8px;font-family:'Oswald',sans-serif;font-weight:700;font-size:.875rem;text-transform:uppercase;cursor:pointer;text-decoration:none;display:flex;align-items:center;justify-content:center;}</style>`);$('body').append(`<div id="mrk-loading-popup"><div id="mrk-loading-popup__box"><span id="mrk-loading-popup__icon">🎨</span><h2 id="mrk-loading-popup__title">Preparing Your Order</h2><p id="mrk-loading-popup__msg">Locking in your design…</p><div class="mrk-loading-bar-track"><div class="mrk-loading-bar-fill" id="mrk-loading-bar-fill"></div><div class="mrk-loading-pulse"></div></div><p id="mrk-loading-popup__pct">Adding to cart…</p><p id="mrk-loading-popup__slow">Slow connection? Hang tight — your order is processing.</p></div></div><div id="mrk-designhelp-popup"><div id="mrk-designhelp-popup__box"><span id="mrk-designhelp-popup__icon">⚠️</span><h2 id="mrk-designhelp-popup__title">Hold on before you go</h2><p id="mrk-designhelp-popup__body">If you leave this page, <strong>any designs you have uploaded and your current selections will be lost.</strong><br><br>You can always open Design Help in a new tab instead.</p><div class="mrk-designhelp-popup__actions"><button class="mrk-designhelp-popup__btn-stay" id="mrk-designhelp-stay">Stay on this page</button><a href="https://www.saskatoontees.ca/pages/design-help" target="_blank" class="mrk-designhelp-popup__btn-leave" id="mrk-designhelp-leave">Open in new tab</a></div></div></div>`);},
    showLoadingPopup:function(){
      if(!document.getElementById('mrk-loading-popup'))this.injectPopups();
      $('#mrk-loading-bar-fill').css('width','0%');$('#mrk-loading-popup__pct').text('Adding to cart…');$('#mrk-loading-popup__slow').hide();
      if(this._slowTimer)clearTimeout(this._slowTimer);
      this._slowTimer=setTimeout(function(){$('#mrk-loading-popup__slow').fadeIn(400);},8000);
      $('#mrk-loading-popup__title').text('Preparing Your Order');$('#mrk-loading-popup__icon').text('🎨');
      const msgs=['Locking in your design…','Capturing print placement…','Saving your artwork…','Checking everything looks perfect…','Almost there…'];
      let mi=0;$('#mrk-loading-popup__msg').text(msgs[0]);
      if(this._msgInterval)clearInterval(this._msgInterval);
      this._msgInterval=setInterval(()=>{mi=(mi+1)%msgs.length;$('#mrk-loading-popup__msg').css('opacity',0);setTimeout(()=>{$('#mrk-loading-popup__msg').text(msgs[mi]).css('opacity',1);},300);},2400);
      $('#mrk-loading-popup').addClass('active');
      $('#mrk-submit-btn').closest('.mrk-cart-section,.mrk-footer,[class*="mrk-cart"],[class*="mrk-submit"]').add('#mrk-submit-btn').css({'pointer-events':'none','opacity':'0.4'});
    },
    setLoadingStep:function(n){const pct=Math.min(Math.round(((n-1)/4)*100),95);const labels=['','Preparing your design…','Securing your order…','Confirming items…','Adding to cart…'];$('#mrk-loading-bar-fill').css('width',pct+'%');$('#mrk-loading-popup__pct').text(labels[n]||'Processing…');},
    completeLoadingPopup:function(){
      if(this._msgInterval)clearInterval(this._msgInterval);if(this._slowTimer)clearTimeout(this._slowTimer);
      $('#mrk-loading-bar-fill').css('width','100%');$('#mrk-loading-popup__pct').text('Order confirmed!');$('#mrk-loading-popup__slow').hide();
      $('#mrk-loading-popup__title').text("You're All Set! 🎉");$('#mrk-loading-popup__msg').css('opacity',0);
      setTimeout(()=>$('#mrk-loading-popup__msg').text('Taking you to your cart…').css('opacity',1),300);$('#mrk-loading-popup__icon').text('🎉');
    },
    hideLoadingPopup:function(){
      if(this._msgInterval)clearInterval(this._msgInterval);if(this._slowTimer)clearTimeout(this._slowTimer);
      $('#mrk-loading-popup').removeClass('active');
      $('#mrk-submit-btn').closest('.mrk-cart-section,.mrk-footer,[class*="mrk-cart"],[class*="mrk-submit"]').add('#mrk-submit-btn').css({'pointer-events':'','opacity':''});
    },

    bindDesignHelpPopup:function(){$(document).on('click','.mrk-need-help-with-design',function(e){e.preventDefault();$('#mrk-designhelp-popup').addClass('active');});$(document).on('click','#mrk-designhelp-stay',function(){$('#mrk-designhelp-popup').removeClass('active');});$(document).on('click','#mrk-designhelp-leave',function(){$('#mrk-designhelp-popup').removeClass('active');});$(document).on('click','#mrk-designhelp-popup',function(e){if(e.target===this)$('#mrk-designhelp-popup').removeClass('active');});},

  };

  $(document).ready(()=>{MRK.injectPopups();MRK.bindDesignHelpPopup();MRK.init();});
  window.MRK=MRK;

})(jQuery);

pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
const _pdfContainer=document.querySelector('.mrk-pdf-preview');
if(_pdfContainer){const url=_pdfContainer.getAttribute('file');const cv=document.createElement('canvas');_pdfContainer.appendChild(cv);pdfjsLib.getDocument(url).promise.then(pdf=>pdf.getPage(1).then(page=>{const vp=page.getViewport({scale:1});cv.width=vp.width;cv.height=vp.height;page.render({canvasContext:cv.getContext('2d'),viewport:vp});}));}